var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppstoreQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_795_82616",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 146,
    height: 146
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.60455 39.7521C3.68488 39.7521 4.56067 38.8763 4.56067 37.796C4.56067 36.7156 3.68488 35.8398 2.60455 35.8398C1.52422 35.8398 0.648438 36.7156 0.648438 37.796C0.648438 38.8763 1.52422 39.7521 2.60455 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.60455 55.4015C3.68488 55.4015 4.56067 54.5257 4.56067 53.4454C4.56067 52.365 3.68488 51.4893 2.60455 51.4893C1.52422 51.4893 0.648438 52.365 0.648438 53.4454C0.648438 54.5257 1.52422 55.4015 2.60455 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.60455 59.3136C3.68488 59.3136 4.56067 58.4378 4.56067 57.3575C4.56067 56.2771 3.68488 55.4014 2.60455 55.4014C1.52422 55.4014 0.648438 56.2771 0.648438 57.3575C0.648438 58.4378 1.52422 59.3136 2.60455 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.60455 63.2257C3.68488 63.2257 4.56067 62.3499 4.56067 61.2696C4.56067 60.1893 3.68488 59.3135 2.60455 59.3135C1.52422 59.3135 0.648438 60.1893 0.648438 61.2696C0.648438 62.3499 1.52422 63.2257 2.60455 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.60455 67.1378C3.68488 67.1378 4.56067 66.262 4.56067 65.1817C4.56067 64.1014 3.68488 63.2256 2.60455 63.2256C1.52422 63.2256 0.648438 64.1014 0.648438 65.1817C0.648438 66.262 1.52422 67.1378 2.60455 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.60455 71.0499C3.68488 71.0499 4.56067 70.1741 4.56067 69.0938C4.56067 68.0135 3.68488 67.1377 2.60455 67.1377C1.52422 67.1377 0.648438 68.0135 0.648438 69.0938C0.648438 70.1741 1.52422 71.0499 2.60455 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.60455 78.8741C3.68488 78.8741 4.56067 77.9984 4.56067 76.918C4.56067 75.8377 3.68488 74.9619 2.60455 74.9619C1.52422 74.9619 0.648438 75.8377 0.648438 76.918C0.648438 77.9984 1.52422 78.8741 2.60455 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.60455 90.6114C3.68488 90.6114 4.56067 89.7357 4.56067 88.6553C4.56067 87.575 3.68488 86.6992 2.60455 86.6992C1.52422 86.6992 0.648438 87.575 0.648438 88.6553C0.648438 89.7357 1.52422 90.6114 2.60455 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M2.60455 94.5236C3.68488 94.5236 4.56067 93.6478 4.56067 92.5674C4.56067 91.4871 3.68488 90.6113 2.60455 90.6113C1.52422 90.6113 0.648438 91.4871 0.648438 92.5674C0.648438 93.6478 1.52422 94.5236 2.60455 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M2.60455 98.4357C3.68488 98.4357 4.56067 97.5599 4.56067 96.4796C4.56067 95.3992 3.68488 94.5234 2.60455 94.5234C1.52422 94.5234 0.648438 95.3992 0.648438 96.4796C0.648438 97.5599 1.52422 98.4357 2.60455 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M2.60455 102.348C3.68488 102.348 4.56067 101.472 4.56067 100.392C4.56067 99.3113 3.68488 98.4355 2.60455 98.4355C1.52422 98.4355 0.648438 99.3113 0.648438 100.392C0.648438 101.472 1.52422 102.348 2.60455 102.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M2.60455 106.26C3.68488 106.26 4.56067 105.384 4.56067 104.304C4.56067 103.223 3.68488 102.348 2.60455 102.348C1.52422 102.348 0.648438 103.223 0.648438 104.304C0.648438 105.384 1.52422 106.26 2.60455 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M2.60455 110.172C3.68488 110.172 4.56067 109.296 4.56067 108.216C4.56067 107.136 3.68488 106.26 2.60455 106.26C1.52422 106.26 0.648438 107.136 0.648438 108.216C0.648438 109.296 1.52422 110.172 2.60455 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M6.51666 39.7521C7.59699 39.7521 8.47278 38.8763 8.47278 37.796C8.47278 36.7156 7.59699 35.8398 6.51666 35.8398C5.43633 35.8398 4.56055 36.7156 4.56055 37.796C4.56055 38.8763 5.43633 39.7521 6.51666 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M6.51666 59.3136C7.59699 59.3136 8.47278 58.4378 8.47278 57.3575C8.47278 56.2771 7.59699 55.4014 6.51666 55.4014C5.43633 55.4014 4.56055 56.2771 4.56055 57.3575C4.56055 58.4378 5.43633 59.3136 6.51666 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M6.51666 67.1378C7.59699 67.1378 8.47278 66.262 8.47278 65.1817C8.47278 64.1014 7.59699 63.2256 6.51666 63.2256C5.43633 63.2256 4.56055 64.1014 4.56055 65.1817C4.56055 66.262 5.43633 67.1378 6.51666 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M6.51666 71.0499C7.59699 71.0499 8.47278 70.1741 8.47278 69.0938C8.47278 68.0135 7.59699 67.1377 6.51666 67.1377C5.43633 67.1377 4.56055 68.0135 4.56055 69.0938C4.56055 70.1741 5.43633 71.0499 6.51666 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M6.51666 78.8741C7.59699 78.8741 8.47278 77.9984 8.47278 76.918C8.47278 75.8377 7.59699 74.9619 6.51666 74.9619C5.43633 74.9619 4.56055 75.8377 4.56055 76.918C4.56055 77.9984 5.43633 78.8741 6.51666 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M6.51666 82.7863C7.59699 82.7863 8.47278 81.9105 8.47278 80.8301C8.47278 79.7498 7.59699 78.874 6.51666 78.874C5.43633 78.874 4.56055 79.7498 4.56055 80.8301C4.56055 81.9105 5.43633 82.7863 6.51666 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M6.51666 86.6993C7.59699 86.6993 8.47278 85.8236 8.47278 84.7432C8.47278 83.6629 7.59699 82.7871 6.51666 82.7871C5.43633 82.7871 4.56055 83.6629 4.56055 84.7432C4.56055 85.8236 5.43633 86.6993 6.51666 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M6.51666 98.4357C7.59699 98.4357 8.47278 97.5599 8.47278 96.4796C8.47278 95.3992 7.59699 94.5234 6.51666 94.5234C5.43633 94.5234 4.56055 95.3992 4.56055 96.4796C4.56055 97.5599 5.43633 98.4357 6.51666 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M6.51666 102.348C7.59699 102.348 8.47278 101.472 8.47278 100.392C8.47278 99.3113 7.59699 98.4355 6.51666 98.4355C5.43633 98.4355 4.56055 99.3113 4.56055 100.392C4.56055 101.472 5.43633 102.348 6.51666 102.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M6.51666 114.084C7.59699 114.084 8.47278 113.208 8.47278 112.128C8.47278 111.048 7.59699 110.172 6.51666 110.172C5.43633 110.172 4.56055 111.048 4.56055 112.128C4.56055 113.208 5.43633 114.084 6.51666 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M10.4288 35.84C11.5091 35.84 12.3849 34.9642 12.3849 33.8838C12.3849 32.8035 11.5091 31.9277 10.4288 31.9277C9.34844 31.9277 8.47266 32.8035 8.47266 33.8838C8.47266 34.9642 9.34844 35.84 10.4288 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M10.4288 51.4884C11.5091 51.4884 12.3849 50.6126 12.3849 49.5323C12.3849 48.452 11.5091 47.5762 10.4288 47.5762C9.34844 47.5762 8.47266 48.452 8.47266 49.5323C8.47266 50.6126 9.34844 51.4884 10.4288 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M10.4288 55.4015C11.5091 55.4015 12.3849 54.5257 12.3849 53.4454C12.3849 52.365 11.5091 51.4893 10.4288 51.4893C9.34844 51.4893 8.47266 52.365 8.47266 53.4454C8.47266 54.5257 9.34844 55.4015 10.4288 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M10.4288 59.3136C11.5091 59.3136 12.3849 58.4378 12.3849 57.3575C12.3849 56.2771 11.5091 55.4014 10.4288 55.4014C9.34844 55.4014 8.47266 56.2771 8.47266 57.3575C8.47266 58.4378 9.34844 59.3136 10.4288 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M10.4288 63.2257C11.5091 63.2257 12.3849 62.3499 12.3849 61.2696C12.3849 60.1893 11.5091 59.3135 10.4288 59.3135C9.34844 59.3135 8.47266 60.1893 8.47266 61.2696C8.47266 62.3499 9.34844 63.2257 10.4288 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M10.4288 67.1378C11.5091 67.1378 12.3849 66.262 12.3849 65.1817C12.3849 64.1014 11.5091 63.2256 10.4288 63.2256C9.34844 63.2256 8.47266 64.1014 8.47266 65.1817C8.47266 66.262 9.34844 67.1378 10.4288 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M10.4288 71.0499C11.5091 71.0499 12.3849 70.1741 12.3849 69.0938C12.3849 68.0135 11.5091 67.1377 10.4288 67.1377C9.34844 67.1377 8.47266 68.0135 8.47266 69.0938C8.47266 70.1741 9.34844 71.0499 10.4288 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M10.4288 74.962C11.5091 74.962 12.3849 74.0863 12.3849 73.0059C12.3849 71.9256 11.5091 71.0498 10.4288 71.0498C9.34844 71.0498 8.47266 71.9256 8.47266 73.0059C8.47266 74.0863 9.34844 74.962 10.4288 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M10.4288 78.8741C11.5091 78.8741 12.3849 77.9984 12.3849 76.918C12.3849 75.8377 11.5091 74.9619 10.4288 74.9619C9.34844 74.9619 8.47266 75.8377 8.47266 76.918C8.47266 77.9984 9.34844 78.8741 10.4288 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M10.4288 82.7863C11.5091 82.7863 12.3849 81.9105 12.3849 80.8301C12.3849 79.7498 11.5091 78.874 10.4288 78.874C9.34844 78.874 8.47266 79.7498 8.47266 80.8301C8.47266 81.9105 9.34844 82.7863 10.4288 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M10.4288 86.6993C11.5091 86.6993 12.3849 85.8236 12.3849 84.7432C12.3849 83.6629 11.5091 82.7871 10.4288 82.7871C9.34844 82.7871 8.47266 83.6629 8.47266 84.7432C8.47266 85.8236 9.34844 86.6993 10.4288 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M10.4288 94.5236C11.5091 94.5236 12.3849 93.6478 12.3849 92.5674C12.3849 91.4871 11.5091 90.6113 10.4288 90.6113C9.34844 90.6113 8.47266 91.4871 8.47266 92.5674C8.47266 93.6478 9.34844 94.5236 10.4288 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M10.4288 106.26C11.5091 106.26 12.3849 105.384 12.3849 104.304C12.3849 103.223 11.5091 102.348 10.4288 102.348C9.34844 102.348 8.47266 103.223 8.47266 104.304C8.47266 105.384 9.34844 106.26 10.4288 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M10.4288 110.172C11.5091 110.172 12.3849 109.296 12.3849 108.216C12.3849 107.136 11.5091 106.26 10.4288 106.26C9.34844 106.26 8.47266 107.136 8.47266 108.216C8.47266 109.296 9.34844 110.172 10.4288 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M14.3409 39.7521C15.4212 39.7521 16.297 38.8763 16.297 37.796C16.297 36.7156 15.4212 35.8398 14.3409 35.8398C13.2605 35.8398 12.3848 36.7156 12.3848 37.796C12.3848 38.8763 13.2605 39.7521 14.3409 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M14.3409 43.6642C15.4212 43.6642 16.297 42.7884 16.297 41.7081C16.297 40.6277 15.4212 39.752 14.3409 39.752C13.2605 39.752 12.3848 40.6277 12.3848 41.7081C12.3848 42.7884 13.2605 43.6642 14.3409 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M14.3409 51.4884C15.4212 51.4884 16.297 50.6126 16.297 49.5323C16.297 48.452 15.4212 47.5762 14.3409 47.5762C13.2605 47.5762 12.3848 48.452 12.3848 49.5323C12.3848 50.6126 13.2605 51.4884 14.3409 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M14.3409 55.4015C15.4212 55.4015 16.297 54.5257 16.297 53.4454C16.297 52.365 15.4212 51.4893 14.3409 51.4893C13.2605 51.4893 12.3848 52.365 12.3848 53.4454C12.3848 54.5257 13.2605 55.4015 14.3409 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M14.3409 63.2257C15.4212 63.2257 16.297 62.3499 16.297 61.2696C16.297 60.1893 15.4212 59.3135 14.3409 59.3135C13.2605 59.3135 12.3848 60.1893 12.3848 61.2696C12.3848 62.3499 13.2605 63.2257 14.3409 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M14.3409 67.1378C15.4212 67.1378 16.297 66.262 16.297 65.1817C16.297 64.1014 15.4212 63.2256 14.3409 63.2256C13.2605 63.2256 12.3848 64.1014 12.3848 65.1817C12.3848 66.262 13.2605 67.1378 14.3409 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M14.3409 90.6114C15.4212 90.6114 16.297 89.7357 16.297 88.6553C16.297 87.575 15.4212 86.6992 14.3409 86.6992C13.2605 86.6992 12.3848 87.575 12.3848 88.6553C12.3848 89.7357 13.2605 90.6114 14.3409 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M14.3409 94.5236C15.4212 94.5236 16.297 93.6478 16.297 92.5674C16.297 91.4871 15.4212 90.6113 14.3409 90.6113C13.2605 90.6113 12.3848 91.4871 12.3848 92.5674C12.3848 93.6478 13.2605 94.5236 14.3409 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M14.3409 98.4357C15.4212 98.4357 16.297 97.5599 16.297 96.4796C16.297 95.3992 15.4212 94.5234 14.3409 94.5234C13.2605 94.5234 12.3848 95.3992 12.3848 96.4796C12.3848 97.5599 13.2605 98.4357 14.3409 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M14.3409 102.348C15.4212 102.348 16.297 101.472 16.297 100.392C16.297 99.3113 15.4212 98.4355 14.3409 98.4355C13.2605 98.4355 12.3848 99.3113 12.3848 100.392C12.3848 101.472 13.2605 102.348 14.3409 102.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M14.3409 106.26C15.4212 106.26 16.297 105.384 16.297 104.304C16.297 103.223 15.4212 102.348 14.3409 102.348C13.2605 102.348 12.3848 103.223 12.3848 104.304C12.3848 105.384 13.2605 106.26 14.3409 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M14.3409 114.084C15.4212 114.084 16.297 113.208 16.297 112.128C16.297 111.048 15.4212 110.172 14.3409 110.172C13.2605 110.172 12.3848 111.048 12.3848 112.128C12.3848 113.208 13.2605 114.084 14.3409 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M18.254 35.84C19.3343 35.84 20.2101 34.9642 20.2101 33.8838C20.2101 32.8035 19.3343 31.9277 18.254 31.9277C17.1736 31.9277 16.2979 32.8035 16.2979 33.8838C16.2979 34.9642 17.1736 35.84 18.254 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M18.254 39.7521C19.3343 39.7521 20.2101 38.8763 20.2101 37.796C20.2101 36.7156 19.3343 35.8398 18.254 35.8398C17.1736 35.8398 16.2979 36.7156 16.2979 37.796C16.2979 38.8763 17.1736 39.7521 18.254 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M18.254 51.4884C19.3343 51.4884 20.2101 50.6126 20.2101 49.5323C20.2101 48.452 19.3343 47.5762 18.254 47.5762C17.1736 47.5762 16.2979 48.452 16.2979 49.5323C16.2979 50.6126 17.1736 51.4884 18.254 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M18.254 55.4015C19.3343 55.4015 20.2101 54.5257 20.2101 53.4454C20.2101 52.365 19.3343 51.4893 18.254 51.4893C17.1736 51.4893 16.2979 52.365 16.2979 53.4454C16.2979 54.5257 17.1736 55.4015 18.254 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M18.254 59.3136C19.3343 59.3136 20.2101 58.4378 20.2101 57.3575C20.2101 56.2771 19.3343 55.4014 18.254 55.4014C17.1736 55.4014 16.2979 56.2771 16.2979 57.3575C16.2979 58.4378 17.1736 59.3136 18.254 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M18.254 67.1378C19.3343 67.1378 20.2101 66.262 20.2101 65.1817C20.2101 64.1014 19.3343 63.2256 18.254 63.2256C17.1736 63.2256 16.2979 64.1014 16.2979 65.1817C16.2979 66.262 17.1736 67.1378 18.254 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M18.254 74.962C19.3343 74.962 20.2101 74.0863 20.2101 73.0059C20.2101 71.9256 19.3343 71.0498 18.254 71.0498C17.1736 71.0498 16.2979 71.9256 16.2979 73.0059C16.2979 74.0863 17.1736 74.962 18.254 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M18.254 78.8741C19.3343 78.8741 20.2101 77.9984 20.2101 76.918C20.2101 75.8377 19.3343 74.9619 18.254 74.9619C17.1736 74.9619 16.2979 75.8377 16.2979 76.918C16.2979 77.9984 17.1736 78.8741 18.254 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M18.254 94.5236C19.3343 94.5236 20.2101 93.6478 20.2101 92.5674C20.2101 91.4871 19.3343 90.6113 18.254 90.6113C17.1736 90.6113 16.2979 91.4871 16.2979 92.5674C16.2979 93.6478 17.1736 94.5236 18.254 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M18.254 102.348C19.3343 102.348 20.2101 101.472 20.2101 100.392C20.2101 99.3113 19.3343 98.4355 18.254 98.4355C17.1736 98.4355 16.2979 99.3113 16.2979 100.392C16.2979 101.472 17.1736 102.348 18.254 102.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M18.254 110.172C19.3343 110.172 20.2101 109.296 20.2101 108.216C20.2101 107.136 19.3343 106.26 18.254 106.26C17.1736 106.26 16.2979 107.136 16.2979 108.216C16.2979 109.296 17.1736 110.172 18.254 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M22.1661 35.84C23.2464 35.84 24.1222 34.9642 24.1222 33.8838C24.1222 32.8035 23.2464 31.9277 22.1661 31.9277C21.0857 31.9277 20.21 32.8035 20.21 33.8838C20.21 34.9642 21.0857 35.84 22.1661 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M22.1661 51.4884C23.2464 51.4884 24.1222 50.6126 24.1222 49.5323C24.1222 48.452 23.2464 47.5762 22.1661 47.5762C21.0857 47.5762 20.21 48.452 20.21 49.5323C20.21 50.6126 21.0857 51.4884 22.1661 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M22.1661 59.3136C23.2464 59.3136 24.1222 58.4378 24.1222 57.3575C24.1222 56.2771 23.2464 55.4014 22.1661 55.4014C21.0857 55.4014 20.21 56.2771 20.21 57.3575C20.21 58.4378 21.0857 59.3136 22.1661 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M22.1661 90.6114C23.2464 90.6114 24.1222 89.7357 24.1222 88.6553C24.1222 87.575 23.2464 86.6992 22.1661 86.6992C21.0857 86.6992 20.21 87.575 20.21 88.6553C20.21 89.7357 21.0857 90.6114 22.1661 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M22.1661 98.4357C23.2464 98.4357 24.1222 97.5599 24.1222 96.4796C24.1222 95.3992 23.2464 94.5234 22.1661 94.5234C21.0857 94.5234 20.21 95.3992 20.21 96.4796C20.21 97.5599 21.0857 98.4357 22.1661 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M22.1661 114.084C23.2464 114.084 24.1222 113.208 24.1222 112.128C24.1222 111.048 23.2464 110.172 22.1661 110.172C21.0857 110.172 20.21 111.048 20.21 112.128C20.21 113.208 21.0857 114.084 22.1661 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M26.0772 35.84C27.1575 35.84 28.0333 34.9642 28.0333 33.8838C28.0333 32.8035 27.1575 31.9277 26.0772 31.9277C24.9969 31.9277 24.1211 32.8035 24.1211 33.8838C24.1211 34.9642 24.9969 35.84 26.0772 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M26.0772 43.6642C27.1575 43.6642 28.0333 42.7884 28.0333 41.7081C28.0333 40.6277 27.1575 39.752 26.0772 39.752C24.9969 39.752 24.1211 40.6277 24.1211 41.7081C24.1211 42.7884 24.9969 43.6642 26.0772 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M26.0772 51.4884C27.1575 51.4884 28.0333 50.6126 28.0333 49.5323C28.0333 48.452 27.1575 47.5762 26.0772 47.5762C24.9969 47.5762 24.1211 48.452 24.1211 49.5323C24.1211 50.6126 24.9969 51.4884 26.0772 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M26.0772 59.3136C27.1575 59.3136 28.0333 58.4378 28.0333 57.3575C28.0333 56.2771 27.1575 55.4014 26.0772 55.4014C24.9969 55.4014 24.1211 56.2771 24.1211 57.3575C24.1211 58.4378 24.9969 59.3136 26.0772 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M26.0772 67.1378C27.1575 67.1378 28.0333 66.262 28.0333 65.1817C28.0333 64.1014 27.1575 63.2256 26.0772 63.2256C24.9969 63.2256 24.1211 64.1014 24.1211 65.1817C24.1211 66.262 24.9969 67.1378 26.0772 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M26.0772 74.962C27.1575 74.962 28.0333 74.0863 28.0333 73.0059C28.0333 71.9256 27.1575 71.0498 26.0772 71.0498C24.9969 71.0498 24.1211 71.9256 24.1211 73.0059C24.1211 74.0863 24.9969 74.962 26.0772 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M26.0772 82.7863C27.1575 82.7863 28.0333 81.9105 28.0333 80.8301C28.0333 79.7498 27.1575 78.874 26.0772 78.874C24.9969 78.874 24.1211 79.7498 24.1211 80.8301C24.1211 81.9105 24.9969 82.7863 26.0772 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M26.0772 90.6114C27.1575 90.6114 28.0333 89.7357 28.0333 88.6553C28.0333 87.575 27.1575 86.6992 26.0772 86.6992C24.9969 86.6992 24.1211 87.575 24.1211 88.6553C24.1211 89.7357 24.9969 90.6114 26.0772 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M26.0772 98.4357C27.1575 98.4357 28.0333 97.5599 28.0333 96.4796C28.0333 95.3992 27.1575 94.5234 26.0772 94.5234C24.9969 94.5234 24.1211 95.3992 24.1211 96.4796C24.1211 97.5599 24.9969 98.4357 26.0772 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M26.0772 106.26C27.1575 106.26 28.0333 105.384 28.0333 104.304C28.0333 103.223 27.1575 102.348 26.0772 102.348C24.9969 102.348 24.1211 103.223 24.1211 104.304C24.1211 105.384 24.9969 106.26 26.0772 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M26.0772 114.084C27.1575 114.084 28.0333 113.208 28.0333 112.128C28.0333 111.048 27.1575 110.172 26.0772 110.172C24.9969 110.172 24.1211 111.048 24.1211 112.128C24.1211 113.208 24.9969 114.084 26.0772 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M29.9903 39.7521C31.0706 39.7521 31.9464 38.8763 31.9464 37.796C31.9464 36.7156 31.0706 35.8398 29.9903 35.8398C28.91 35.8398 28.0342 36.7156 28.0342 37.796C28.0342 38.8763 28.91 39.7521 29.9903 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M29.9903 47.5763C31.0706 47.5763 31.9464 46.7005 31.9464 45.6202C31.9464 44.5398 31.0706 43.6641 29.9903 43.6641C28.91 43.6641 28.0342 44.5398 28.0342 45.6202C28.0342 46.7005 28.91 47.5763 29.9903 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M29.9903 63.2257C31.0706 63.2257 31.9464 62.3499 31.9464 61.2696C31.9464 60.1893 31.0706 59.3135 29.9903 59.3135C28.91 59.3135 28.0342 60.1893 28.0342 61.2696C28.0342 62.3499 28.91 63.2257 29.9903 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M29.9903 78.8741C31.0706 78.8741 31.9464 77.9984 31.9464 76.918C31.9464 75.8377 31.0706 74.9619 29.9903 74.9619C28.91 74.9619 28.0342 75.8377 28.0342 76.918C28.0342 77.9984 28.91 78.8741 29.9903 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M29.9903 82.7863C31.0706 82.7863 31.9464 81.9105 31.9464 80.8301C31.9464 79.7498 31.0706 78.874 29.9903 78.874C28.91 78.874 28.0342 79.7498 28.0342 80.8301C28.0342 81.9105 28.91 82.7863 29.9903 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M29.9903 86.6993C31.0706 86.6993 31.9464 85.8236 31.9464 84.7432C31.9464 83.6629 31.0706 82.7871 29.9903 82.7871C28.91 82.7871 28.0342 83.6629 28.0342 84.7432C28.0342 85.8236 28.91 86.6993 29.9903 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M29.9903 90.6114C31.0706 90.6114 31.9464 89.7357 31.9464 88.6553C31.9464 87.575 31.0706 86.6992 29.9903 86.6992C28.91 86.6992 28.0342 87.575 28.0342 88.6553C28.0342 89.7357 28.91 90.6114 29.9903 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M29.9903 94.5236C31.0706 94.5236 31.9464 93.6478 31.9464 92.5674C31.9464 91.4871 31.0706 90.6113 29.9903 90.6113C28.91 90.6113 28.0342 91.4871 28.0342 92.5674C28.0342 93.6478 28.91 94.5236 29.9903 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M29.9903 98.4357C31.0706 98.4357 31.9464 97.5599 31.9464 96.4796C31.9464 95.3992 31.0706 94.5234 29.9903 94.5234C28.91 94.5234 28.0342 95.3992 28.0342 96.4796C28.0342 97.5599 28.91 98.4357 29.9903 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M33.9024 8.45422C34.9827 8.45422 35.8585 7.57844 35.8585 6.49811C35.8585 5.41777 34.9827 4.54199 33.9024 4.54199C32.8221 4.54199 31.9463 5.41777 31.9463 6.49811C31.9463 7.57844 32.8221 8.45422 33.9024 8.45422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M33.9024 20.1905C34.9827 20.1905 35.8585 19.3148 35.8585 18.2344C35.8585 17.1541 34.9827 16.2783 33.9024 16.2783C32.8221 16.2783 31.9463 17.1541 31.9463 18.2344C31.9463 19.3148 32.8221 20.1905 33.9024 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M33.9024 28.0157C34.9827 28.0157 35.8585 27.14 35.8585 26.0596C35.8585 24.9793 34.9827 24.1035 33.9024 24.1035C32.8221 24.1035 31.9463 24.9793 31.9463 26.0596C31.9463 27.14 32.8221 28.0157 33.9024 28.0157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M33.9024 35.84C34.9827 35.84 35.8585 34.9642 35.8585 33.8838C35.8585 32.8035 34.9827 31.9277 33.9024 31.9277C32.8221 31.9277 31.9463 32.8035 31.9463 33.8838C31.9463 34.9642 32.8221 35.84 33.9024 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M33.9024 59.3136C34.9827 59.3136 35.8585 58.4378 35.8585 57.3575C35.8585 56.2771 34.9827 55.4014 33.9024 55.4014C32.8221 55.4014 31.9463 56.2771 31.9463 57.3575C31.9463 58.4378 32.8221 59.3136 33.9024 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M33.9024 63.2257C34.9827 63.2257 35.8585 62.3499 35.8585 61.2696C35.8585 60.1893 34.9827 59.3135 33.9024 59.3135C32.8221 59.3135 31.9463 60.1893 31.9463 61.2696C31.9463 62.3499 32.8221 63.2257 33.9024 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M33.9024 74.962C34.9827 74.962 35.8585 74.0863 35.8585 73.0059C35.8585 71.9256 34.9827 71.0498 33.9024 71.0498C32.8221 71.0498 31.9463 71.9256 31.9463 73.0059C31.9463 74.0863 32.8221 74.962 33.9024 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M33.9024 82.7863C34.9827 82.7863 35.8585 81.9105 35.8585 80.8301C35.8585 79.7498 34.9827 78.874 33.9024 78.874C32.8221 78.874 31.9463 79.7498 31.9463 80.8301C31.9463 81.9105 32.8221 82.7863 33.9024 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M33.9024 86.6993C34.9827 86.6993 35.8585 85.8236 35.8585 84.7432C35.8585 83.6629 34.9827 82.7871 33.9024 82.7871C32.8221 82.7871 31.9463 83.6629 31.9463 84.7432C31.9463 85.8236 32.8221 86.6993 33.9024 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M33.9024 90.6114C34.9827 90.6114 35.8585 89.7357 35.8585 88.6553C35.8585 87.575 34.9827 86.6992 33.9024 86.6992C32.8221 86.6992 31.9463 87.575 31.9463 88.6553C31.9463 89.7357 32.8221 90.6114 33.9024 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M33.9024 94.5236C34.9827 94.5236 35.8585 93.6478 35.8585 92.5674C35.8585 91.4871 34.9827 90.6113 33.9024 90.6113C32.8221 90.6113 31.9463 91.4871 31.9463 92.5674C31.9463 93.6478 32.8221 94.5236 33.9024 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M33.9024 98.4357C34.9827 98.4357 35.8585 97.5599 35.8585 96.4796C35.8585 95.3992 34.9827 94.5234 33.9024 94.5234C32.8221 94.5234 31.9463 95.3992 31.9463 96.4796C31.9463 97.5599 32.8221 98.4357 33.9024 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M33.9024 106.26C34.9827 106.26 35.8585 105.384 35.8585 104.304C35.8585 103.223 34.9827 102.348 33.9024 102.348C32.8221 102.348 31.9463 103.223 31.9463 104.304C31.9463 105.384 32.8221 106.26 33.9024 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M33.9024 110.172C34.9827 110.172 35.8585 109.296 35.8585 108.216C35.8585 107.136 34.9827 106.26 33.9024 106.26C32.8221 106.26 31.9463 107.136 31.9463 108.216C31.9463 109.296 32.8221 110.172 33.9024 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M33.9024 114.084C34.9827 114.084 35.8585 113.208 35.8585 112.128C35.8585 111.048 34.9827 110.172 33.9024 110.172C32.8221 110.172 31.9463 111.048 31.9463 112.128C31.9463 113.208 32.8221 114.084 33.9024 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M33.9024 117.997C34.9827 117.997 35.8585 117.121 35.8585 116.041C35.8585 114.961 34.9827 114.085 33.9024 114.085C32.8221 114.085 31.9463 114.961 31.9463 116.041C31.9463 117.121 32.8221 117.997 33.9024 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M33.9024 125.821C34.9827 125.821 35.8585 124.946 35.8585 123.865C35.8585 122.785 34.9827 121.909 33.9024 121.909C32.8221 121.909 31.9463 122.785 31.9463 123.865C31.9463 124.946 32.8221 125.821 33.9024 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M33.9024 129.734C34.9827 129.734 35.8585 128.858 35.8585 127.777C35.8585 126.697 34.9827 125.821 33.9024 125.821C32.8221 125.821 31.9463 126.697 31.9463 127.777C31.9463 128.858 32.8221 129.734 33.9024 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M33.9024 137.558C34.9827 137.558 35.8585 136.682 35.8585 135.602C35.8585 134.521 34.9827 133.646 33.9024 133.646C32.8221 133.646 31.9463 134.521 31.9463 135.602C31.9463 136.682 32.8221 137.558 33.9024 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M37.8155 8.45422C38.8958 8.45422 39.7716 7.57844 39.7716 6.49811C39.7716 5.41777 38.8958 4.54199 37.8155 4.54199C36.7352 4.54199 35.8594 5.41777 35.8594 6.49811C35.8594 7.57844 36.7352 8.45422 37.8155 8.45422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M37.8155 39.7521C38.8958 39.7521 39.7716 38.8763 39.7716 37.796C39.7716 36.7156 38.8958 35.8398 37.8155 35.8398C36.7352 35.8398 35.8594 36.7156 35.8594 37.796C35.8594 38.8763 36.7352 39.7521 37.8155 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M37.8155 43.6642C38.8958 43.6642 39.7716 42.7884 39.7716 41.7081C39.7716 40.6277 38.8958 39.752 37.8155 39.752C36.7352 39.752 35.8594 40.6277 35.8594 41.7081C35.8594 42.7884 36.7352 43.6642 37.8155 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M37.8155 59.3136C38.8958 59.3136 39.7716 58.4378 39.7716 57.3575C39.7716 56.2771 38.8958 55.4014 37.8155 55.4014C36.7352 55.4014 35.8594 56.2771 35.8594 57.3575C35.8594 58.4378 36.7352 59.3136 37.8155 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M37.8155 82.7863C38.8958 82.7863 39.7716 81.9105 39.7716 80.8301C39.7716 79.7498 38.8958 78.874 37.8155 78.874C36.7352 78.874 35.8594 79.7498 35.8594 80.8301C35.8594 81.9105 36.7352 82.7863 37.8155 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M37.8155 94.5236C38.8958 94.5236 39.7716 93.6478 39.7716 92.5674C39.7716 91.4871 38.8958 90.6113 37.8155 90.6113C36.7352 90.6113 35.8594 91.4871 35.8594 92.5674C35.8594 93.6478 36.7352 94.5236 37.8155 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M37.8155 110.172C38.8958 110.172 39.7716 109.296 39.7716 108.216C39.7716 107.136 38.8958 106.26 37.8155 106.26C36.7352 106.26 35.8594 107.136 35.8594 108.216C35.8594 109.296 36.7352 110.172 37.8155 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M37.8155 117.997C38.8958 117.997 39.7716 117.121 39.7716 116.041C39.7716 114.961 38.8958 114.085 37.8155 114.085C36.7352 114.085 35.8594 114.961 35.8594 116.041C35.8594 117.121 36.7352 117.997 37.8155 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M37.8155 125.821C38.8958 125.821 39.7716 124.946 39.7716 123.865C39.7716 122.785 38.8958 121.909 37.8155 121.909C36.7352 121.909 35.8594 122.785 35.8594 123.865C35.8594 124.946 36.7352 125.821 37.8155 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M37.8155 129.734C38.8958 129.734 39.7716 128.858 39.7716 127.777C39.7716 126.697 38.8958 125.821 37.8155 125.821C36.7352 125.821 35.8594 126.697 35.8594 127.777C35.8594 128.858 36.7352 129.734 37.8155 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M37.8155 133.646C38.8958 133.646 39.7716 132.77 39.7716 131.69C39.7716 130.609 38.8958 129.733 37.8155 129.733C36.7352 129.733 35.8594 130.609 35.8594 131.69C35.8594 132.77 36.7352 133.646 37.8155 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M37.8155 137.558C38.8958 137.558 39.7716 136.682 39.7716 135.602C39.7716 134.521 38.8958 133.646 37.8155 133.646C36.7352 133.646 35.8594 134.521 35.8594 135.602C35.8594 136.682 36.7352 137.558 37.8155 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M41.7266 4.54211C42.807 4.54211 43.6827 3.66633 43.6827 2.586C43.6827 1.50567 42.807 0.629883 41.7266 0.629883C40.6463 0.629883 39.7705 1.50567 39.7705 2.586C39.7705 3.66633 40.6463 4.54211 41.7266 4.54211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M41.7266 16.2784C42.807 16.2784 43.6827 15.4027 43.6827 14.3223C43.6827 13.242 42.807 12.3662 41.7266 12.3662C40.6463 12.3662 39.7705 13.242 39.7705 14.3223C39.7705 15.4027 40.6463 16.2784 41.7266 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M41.7266 28.0157C42.807 28.0157 43.6827 27.14 43.6827 26.0596C43.6827 24.9793 42.807 24.1035 41.7266 24.1035C40.6463 24.1035 39.7705 24.9793 39.7705 26.0596C39.7705 27.14 40.6463 28.0157 41.7266 28.0157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M41.7266 31.9279C42.807 31.9279 43.6827 31.0521 43.6827 29.9717C43.6827 28.8914 42.807 28.0156 41.7266 28.0156C40.6463 28.0156 39.7705 28.8914 39.7705 29.9717C39.7705 31.0521 40.6463 31.9279 41.7266 31.9279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M41.7266 39.7521C42.807 39.7521 43.6827 38.8763 43.6827 37.796C43.6827 36.7156 42.807 35.8398 41.7266 35.8398C40.6463 35.8398 39.7705 36.7156 39.7705 37.796C39.7705 38.8763 40.6463 39.7521 41.7266 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M41.7266 47.5763C42.807 47.5763 43.6827 46.7005 43.6827 45.6202C43.6827 44.5398 42.807 43.6641 41.7266 43.6641C40.6463 43.6641 39.7705 44.5398 39.7705 45.6202C39.7705 46.7005 40.6463 47.5763 41.7266 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M41.7266 51.4884C42.807 51.4884 43.6827 50.6126 43.6827 49.5323C43.6827 48.452 42.807 47.5762 41.7266 47.5762C40.6463 47.5762 39.7705 48.452 39.7705 49.5323C39.7705 50.6126 40.6463 51.4884 41.7266 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M41.7266 55.4015C42.807 55.4015 43.6827 54.5257 43.6827 53.4454C43.6827 52.365 42.807 51.4893 41.7266 51.4893C40.6463 51.4893 39.7705 52.365 39.7705 53.4454C39.7705 54.5257 40.6463 55.4015 41.7266 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M41.7266 67.1378C42.807 67.1378 43.6827 66.262 43.6827 65.1817C43.6827 64.1014 42.807 63.2256 41.7266 63.2256C40.6463 63.2256 39.7705 64.1014 39.7705 65.1817C39.7705 66.262 40.6463 67.1378 41.7266 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M41.7266 86.6993C42.807 86.6993 43.6827 85.8236 43.6827 84.7432C43.6827 83.6629 42.807 82.7871 41.7266 82.7871C40.6463 82.7871 39.7705 83.6629 39.7705 84.7432C39.7705 85.8236 40.6463 86.6993 41.7266 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M41.7266 94.5236C42.807 94.5236 43.6827 93.6478 43.6827 92.5674C43.6827 91.4871 42.807 90.6113 41.7266 90.6113C40.6463 90.6113 39.7705 91.4871 39.7705 92.5674C39.7705 93.6478 40.6463 94.5236 41.7266 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M41.7266 98.4357C42.807 98.4357 43.6827 97.5599 43.6827 96.4796C43.6827 95.3992 42.807 94.5234 41.7266 94.5234C40.6463 94.5234 39.7705 95.3992 39.7705 96.4796C39.7705 97.5599 40.6463 98.4357 41.7266 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M41.7266 102.348C42.807 102.348 43.6827 101.472 43.6827 100.392C43.6827 99.3113 42.807 98.4355 41.7266 98.4355C40.6463 98.4355 39.7705 99.3113 39.7705 100.392C39.7705 101.472 40.6463 102.348 41.7266 102.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M41.7266 106.26C42.807 106.26 43.6827 105.384 43.6827 104.304C43.6827 103.223 42.807 102.348 41.7266 102.348C40.6463 102.348 39.7705 103.223 39.7705 104.304C39.7705 105.384 40.6463 106.26 41.7266 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M41.7266 110.172C42.807 110.172 43.6827 109.296 43.6827 108.216C43.6827 107.136 42.807 106.26 41.7266 106.26C40.6463 106.26 39.7705 107.136 39.7705 108.216C39.7705 109.296 40.6463 110.172 41.7266 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M41.7266 117.997C42.807 117.997 43.6827 117.121 43.6827 116.041C43.6827 114.961 42.807 114.085 41.7266 114.085C40.6463 114.085 39.7705 114.961 39.7705 116.041C39.7705 117.121 40.6463 117.997 41.7266 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M41.7266 133.646C42.807 133.646 43.6827 132.77 43.6827 131.69C43.6827 130.609 42.807 129.733 41.7266 129.733C40.6463 129.733 39.7705 130.609 39.7705 131.69C39.7705 132.77 40.6463 133.646 41.7266 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M45.6397 4.54211C46.72 4.54211 47.5958 3.66633 47.5958 2.586C47.5958 1.50567 46.72 0.629883 45.6397 0.629883C44.5594 0.629883 43.6836 1.50567 43.6836 2.586C43.6836 3.66633 44.5594 4.54211 45.6397 4.54211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M45.6397 12.3663C46.72 12.3663 47.5958 11.4905 47.5958 10.4102C47.5958 9.32988 46.72 8.4541 45.6397 8.4541C44.5594 8.4541 43.6836 9.32988 43.6836 10.4102C43.6836 11.4905 44.5594 12.3663 45.6397 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M45.6397 47.5763C46.72 47.5763 47.5958 46.7005 47.5958 45.6202C47.5958 44.5398 46.72 43.6641 45.6397 43.6641C44.5594 43.6641 43.6836 44.5398 43.6836 45.6202C43.6836 46.7005 44.5594 47.5763 45.6397 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M45.6397 51.4884C46.72 51.4884 47.5958 50.6126 47.5958 49.5323C47.5958 48.452 46.72 47.5762 45.6397 47.5762C44.5594 47.5762 43.6836 48.452 43.6836 49.5323C43.6836 50.6126 44.5594 51.4884 45.6397 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M45.6397 55.4015C46.72 55.4015 47.5958 54.5257 47.5958 53.4454C47.5958 52.365 46.72 51.4893 45.6397 51.4893C44.5594 51.4893 43.6836 52.365 43.6836 53.4454C43.6836 54.5257 44.5594 55.4015 45.6397 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M45.6397 59.3136C46.72 59.3136 47.5958 58.4378 47.5958 57.3575C47.5958 56.2771 46.72 55.4014 45.6397 55.4014C44.5594 55.4014 43.6836 56.2771 43.6836 57.3575C43.6836 58.4378 44.5594 59.3136 45.6397 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M45.6397 63.2257C46.72 63.2257 47.5958 62.3499 47.5958 61.2696C47.5958 60.1893 46.72 59.3135 45.6397 59.3135C44.5594 59.3135 43.6836 60.1893 43.6836 61.2696C43.6836 62.3499 44.5594 63.2257 45.6397 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M45.6397 78.8741C46.72 78.8741 47.5958 77.9984 47.5958 76.918C47.5958 75.8377 46.72 74.9619 45.6397 74.9619C44.5594 74.9619 43.6836 75.8377 43.6836 76.918C43.6836 77.9984 44.5594 78.8741 45.6397 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M45.6397 86.6993C46.72 86.6993 47.5958 85.8236 47.5958 84.7432C47.5958 83.6629 46.72 82.7871 45.6397 82.7871C44.5594 82.7871 43.6836 83.6629 43.6836 84.7432C43.6836 85.8236 44.5594 86.6993 45.6397 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M45.6397 98.4357C46.72 98.4357 47.5958 97.5599 47.5958 96.4796C47.5958 95.3992 46.72 94.5234 45.6397 94.5234C44.5594 94.5234 43.6836 95.3992 43.6836 96.4796C43.6836 97.5599 44.5594 98.4357 45.6397 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M45.6397 106.26C46.72 106.26 47.5958 105.384 47.5958 104.304C47.5958 103.223 46.72 102.348 45.6397 102.348C44.5594 102.348 43.6836 103.223 43.6836 104.304C43.6836 105.384 44.5594 106.26 45.6397 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M45.6397 110.172C46.72 110.172 47.5958 109.296 47.5958 108.216C47.5958 107.136 46.72 106.26 45.6397 106.26C44.5594 106.26 43.6836 107.136 43.6836 108.216C43.6836 109.296 44.5594 110.172 45.6397 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M45.6397 117.997C46.72 117.997 47.5958 117.121 47.5958 116.041C47.5958 114.961 46.72 114.085 45.6397 114.085C44.5594 114.085 43.6836 114.961 43.6836 116.041C43.6836 117.121 44.5594 117.997 45.6397 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M45.6397 125.821C46.72 125.821 47.5958 124.946 47.5958 123.865C47.5958 122.785 46.72 121.909 45.6397 121.909C44.5594 121.909 43.6836 122.785 43.6836 123.865C43.6836 124.946 44.5594 125.821 45.6397 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M45.6397 133.646C46.72 133.646 47.5958 132.77 47.5958 131.69C47.5958 130.609 46.72 129.733 45.6397 129.733C44.5594 129.733 43.6836 130.609 43.6836 131.69C43.6836 132.77 44.5594 133.646 45.6397 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M45.6397 137.558C46.72 137.558 47.5958 136.682 47.5958 135.602C47.5958 134.521 46.72 133.646 45.6397 133.646C44.5594 133.646 43.6836 134.521 43.6836 135.602C43.6836 136.682 44.5594 137.558 45.6397 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M49.5518 8.45422C50.6322 8.45422 51.5079 7.57844 51.5079 6.49811C51.5079 5.41777 50.6322 4.54199 49.5518 4.54199C48.4715 4.54199 47.5957 5.41777 47.5957 6.49811C47.5957 7.57844 48.4715 8.45422 49.5518 8.45422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M49.5518 20.1905C50.6322 20.1905 51.5079 19.3148 51.5079 18.2344C51.5079 17.1541 50.6322 16.2783 49.5518 16.2783C48.4715 16.2783 47.5957 17.1541 47.5957 18.2344C47.5957 19.3148 48.4715 20.1905 49.5518 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M49.5518 24.1036C50.6322 24.1036 51.5079 23.2279 51.5079 22.1475C51.5079 21.0672 50.6322 20.1914 49.5518 20.1914C48.4715 20.1914 47.5957 21.0672 47.5957 22.1475C47.5957 23.2279 48.4715 24.1036 49.5518 24.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M49.5518 28.0157C50.6322 28.0157 51.5079 27.14 51.5079 26.0596C51.5079 24.9793 50.6322 24.1035 49.5518 24.1035C48.4715 24.1035 47.5957 24.9793 47.5957 26.0596C47.5957 27.14 48.4715 28.0157 49.5518 28.0157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M49.5518 31.9279C50.6322 31.9279 51.5079 31.0521 51.5079 29.9717C51.5079 28.8914 50.6322 28.0156 49.5518 28.0156C48.4715 28.0156 47.5957 28.8914 47.5957 29.9717C47.5957 31.0521 48.4715 31.9279 49.5518 31.9279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M49.5518 35.84C50.6322 35.84 51.5079 34.9642 51.5079 33.8838C51.5079 32.8035 50.6322 31.9277 49.5518 31.9277C48.4715 31.9277 47.5957 32.8035 47.5957 33.8838C47.5957 34.9642 48.4715 35.84 49.5518 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M49.5518 43.6642C50.6322 43.6642 51.5079 42.7884 51.5079 41.7081C51.5079 40.6277 50.6322 39.752 49.5518 39.752C48.4715 39.752 47.5957 40.6277 47.5957 41.7081C47.5957 42.7884 48.4715 43.6642 49.5518 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M49.5518 47.5763C50.6322 47.5763 51.5079 46.7005 51.5079 45.6202C51.5079 44.5398 50.6322 43.6641 49.5518 43.6641C48.4715 43.6641 47.5957 44.5398 47.5957 45.6202C47.5957 46.7005 48.4715 47.5763 49.5518 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M49.5518 51.4884C50.6322 51.4884 51.5079 50.6126 51.5079 49.5323C51.5079 48.452 50.6322 47.5762 49.5518 47.5762C48.4715 47.5762 47.5957 48.452 47.5957 49.5323C47.5957 50.6126 48.4715 51.4884 49.5518 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M49.5518 63.2257C50.6322 63.2257 51.5079 62.3499 51.5079 61.2696C51.5079 60.1893 50.6322 59.3135 49.5518 59.3135C48.4715 59.3135 47.5957 60.1893 47.5957 61.2696C47.5957 62.3499 48.4715 63.2257 49.5518 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M49.5518 86.6993C50.6322 86.6993 51.5079 85.8236 51.5079 84.7432C51.5079 83.6629 50.6322 82.7871 49.5518 82.7871C48.4715 82.7871 47.5957 83.6629 47.5957 84.7432C47.5957 85.8236 48.4715 86.6993 49.5518 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M49.5518 90.6114C50.6322 90.6114 51.5079 89.7357 51.5079 88.6553C51.5079 87.575 50.6322 86.6992 49.5518 86.6992C48.4715 86.6992 47.5957 87.575 47.5957 88.6553C47.5957 89.7357 48.4715 90.6114 49.5518 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M49.5518 94.5236C50.6322 94.5236 51.5079 93.6478 51.5079 92.5674C51.5079 91.4871 50.6322 90.6113 49.5518 90.6113C48.4715 90.6113 47.5957 91.4871 47.5957 92.5674C47.5957 93.6478 48.4715 94.5236 49.5518 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M49.5518 117.997C50.6322 117.997 51.5079 117.121 51.5079 116.041C51.5079 114.961 50.6322 114.085 49.5518 114.085C48.4715 114.085 47.5957 114.961 47.5957 116.041C47.5957 117.121 48.4715 117.997 49.5518 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M49.5518 121.909C50.6322 121.909 51.5079 121.034 51.5079 119.953C51.5079 118.873 50.6322 117.997 49.5518 117.997C48.4715 117.997 47.5957 118.873 47.5957 119.953C47.5957 121.034 48.4715 121.909 49.5518 121.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M49.5518 125.821C50.6322 125.821 51.5079 124.946 51.5079 123.865C51.5079 122.785 50.6322 121.909 49.5518 121.909C48.4715 121.909 47.5957 122.785 47.5957 123.865C47.5957 124.946 48.4715 125.821 49.5518 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M49.5518 137.558C50.6322 137.558 51.5079 136.682 51.5079 135.602C51.5079 134.521 50.6322 133.646 49.5518 133.646C48.4715 133.646 47.5957 134.521 47.5957 135.602C47.5957 136.682 48.4715 137.558 49.5518 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M49.5518 141.47C50.6322 141.47 51.5079 140.594 51.5079 139.514C51.5079 138.433 50.6322 137.558 49.5518 137.558C48.4715 137.558 47.5957 138.433 47.5957 139.514C47.5957 140.594 48.4715 141.47 49.5518 141.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M49.5518 145.382C50.6322 145.382 51.5079 144.506 51.5079 143.426C51.5079 142.346 50.6322 141.47 49.5518 141.47C48.4715 141.47 47.5957 142.346 47.5957 143.426C47.5957 144.506 48.4715 145.382 49.5518 145.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M53.463 4.54211C54.5433 4.54211 55.4191 3.66633 55.4191 2.586C55.4191 1.50567 54.5433 0.629883 53.463 0.629883C52.3826 0.629883 51.5068 1.50567 51.5068 2.586C51.5068 3.66633 52.3826 4.54211 53.463 4.54211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M53.463 8.45422C54.5433 8.45422 55.4191 7.57844 55.4191 6.49811C55.4191 5.41777 54.5433 4.54199 53.463 4.54199C52.3826 4.54199 51.5068 5.41777 51.5068 6.49811C51.5068 7.57844 52.3826 8.45422 53.463 8.45422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M53.463 16.2784C54.5433 16.2784 55.4191 15.4027 55.4191 14.3223C55.4191 13.242 54.5433 12.3662 53.463 12.3662C52.3826 12.3662 51.5068 13.242 51.5068 14.3223C51.5068 15.4027 52.3826 16.2784 53.463 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M53.463 24.1036C54.5433 24.1036 55.4191 23.2279 55.4191 22.1475C55.4191 21.0672 54.5433 20.1914 53.463 20.1914C52.3826 20.1914 51.5068 21.0672 51.5068 22.1475C51.5068 23.2279 52.3826 24.1036 53.463 24.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M53.463 31.9279C54.5433 31.9279 55.4191 31.0521 55.4191 29.9717C55.4191 28.8914 54.5433 28.0156 53.463 28.0156C52.3826 28.0156 51.5068 28.8914 51.5068 29.9717C51.5068 31.0521 52.3826 31.9279 53.463 31.9279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M53.463 35.84C54.5433 35.84 55.4191 34.9642 55.4191 33.8838C55.4191 32.8035 54.5433 31.9277 53.463 31.9277C52.3826 31.9277 51.5068 32.8035 51.5068 33.8838C51.5068 34.9642 52.3826 35.84 53.463 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M53.463 43.6642C54.5433 43.6642 55.4191 42.7884 55.4191 41.7081C55.4191 40.6277 54.5433 39.752 53.463 39.752C52.3826 39.752 51.5068 40.6277 51.5068 41.7081C51.5068 42.7884 52.3826 43.6642 53.463 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M53.463 47.5763C54.5433 47.5763 55.4191 46.7005 55.4191 45.6202C55.4191 44.5398 54.5433 43.6641 53.463 43.6641C52.3826 43.6641 51.5068 44.5398 51.5068 45.6202C51.5068 46.7005 52.3826 47.5763 53.463 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M53.463 55.4015C54.5433 55.4015 55.4191 54.5257 55.4191 53.4454C55.4191 52.365 54.5433 51.4893 53.463 51.4893C52.3826 51.4893 51.5068 52.365 51.5068 53.4454C51.5068 54.5257 52.3826 55.4015 53.463 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M53.463 78.8741C54.5433 78.8741 55.4191 77.9984 55.4191 76.918C55.4191 75.8377 54.5433 74.9619 53.463 74.9619C52.3826 74.9619 51.5068 75.8377 51.5068 76.918C51.5068 77.9984 52.3826 78.8741 53.463 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M53.463 82.7863C54.5433 82.7863 55.4191 81.9105 55.4191 80.8301C55.4191 79.7498 54.5433 78.874 53.463 78.874C52.3826 78.874 51.5068 79.7498 51.5068 80.8301C51.5068 81.9105 52.3826 82.7863 53.463 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M53.463 90.6114C54.5433 90.6114 55.4191 89.7357 55.4191 88.6553C55.4191 87.575 54.5433 86.6992 53.463 86.6992C52.3826 86.6992 51.5068 87.575 51.5068 88.6553C51.5068 89.7357 52.3826 90.6114 53.463 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M53.463 94.5236C54.5433 94.5236 55.4191 93.6478 55.4191 92.5674C55.4191 91.4871 54.5433 90.6113 53.463 90.6113C52.3826 90.6113 51.5068 91.4871 51.5068 92.5674C51.5068 93.6478 52.3826 94.5236 53.463 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M53.463 106.26C54.5433 106.26 55.4191 105.384 55.4191 104.304C55.4191 103.223 54.5433 102.348 53.463 102.348C52.3826 102.348 51.5068 103.223 51.5068 104.304C51.5068 105.384 52.3826 106.26 53.463 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M53.463 110.172C54.5433 110.172 55.4191 109.296 55.4191 108.216C55.4191 107.136 54.5433 106.26 53.463 106.26C52.3826 106.26 51.5068 107.136 51.5068 108.216C51.5068 109.296 52.3826 110.172 53.463 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M53.463 114.084C54.5433 114.084 55.4191 113.208 55.4191 112.128C55.4191 111.048 54.5433 110.172 53.463 110.172C52.3826 110.172 51.5068 111.048 51.5068 112.128C51.5068 113.208 52.3826 114.084 53.463 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M53.463 117.997C54.5433 117.997 55.4191 117.121 55.4191 116.041C55.4191 114.961 54.5433 114.085 53.463 114.085C52.3826 114.085 51.5068 114.961 51.5068 116.041C51.5068 117.121 52.3826 117.997 53.463 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M53.463 129.734C54.5433 129.734 55.4191 128.858 55.4191 127.777C55.4191 126.697 54.5433 125.821 53.463 125.821C52.3826 125.821 51.5068 126.697 51.5068 127.777C51.5068 128.858 52.3826 129.734 53.463 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M53.463 137.558C54.5433 137.558 55.4191 136.682 55.4191 135.602C55.4191 134.521 54.5433 133.646 53.463 133.646C52.3826 133.646 51.5068 134.521 51.5068 135.602C51.5068 136.682 52.3826 137.558 53.463 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M53.463 141.47C54.5433 141.47 55.4191 140.594 55.4191 139.514C55.4191 138.433 54.5433 137.558 53.463 137.558C52.3826 137.558 51.5068 138.433 51.5068 139.514C51.5068 140.594 52.3826 141.47 53.463 141.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M57.376 4.54211C58.4564 4.54211 59.3322 3.66633 59.3322 2.586C59.3322 1.50567 58.4564 0.629883 57.376 0.629883C56.2957 0.629883 55.4199 1.50567 55.4199 2.586C55.4199 3.66633 56.2957 4.54211 57.376 4.54211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M57.376 16.2784C58.4564 16.2784 59.3322 15.4027 59.3322 14.3223C59.3322 13.242 58.4564 12.3662 57.376 12.3662C56.2957 12.3662 55.4199 13.242 55.4199 14.3223C55.4199 15.4027 56.2957 16.2784 57.376 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M57.376 20.1905C58.4564 20.1905 59.3322 19.3148 59.3322 18.2344C59.3322 17.1541 58.4564 16.2783 57.376 16.2783C56.2957 16.2783 55.4199 17.1541 55.4199 18.2344C55.4199 19.3148 56.2957 20.1905 57.376 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M57.376 24.1036C58.4564 24.1036 59.3322 23.2279 59.3322 22.1475C59.3322 21.0672 58.4564 20.1914 57.376 20.1914C56.2957 20.1914 55.4199 21.0672 55.4199 22.1475C55.4199 23.2279 56.2957 24.1036 57.376 24.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M57.376 28.0157C58.4564 28.0157 59.3322 27.14 59.3322 26.0596C59.3322 24.9793 58.4564 24.1035 57.376 24.1035C56.2957 24.1035 55.4199 24.9793 55.4199 26.0596C55.4199 27.14 56.2957 28.0157 57.376 28.0157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M57.376 31.9279C58.4564 31.9279 59.3322 31.0521 59.3322 29.9717C59.3322 28.8914 58.4564 28.0156 57.376 28.0156C56.2957 28.0156 55.4199 28.8914 55.4199 29.9717C55.4199 31.0521 56.2957 31.9279 57.376 31.9279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M57.376 51.4884C58.4564 51.4884 59.3322 50.6126 59.3322 49.5323C59.3322 48.452 58.4564 47.5762 57.376 47.5762C56.2957 47.5762 55.4199 48.452 55.4199 49.5323C55.4199 50.6126 56.2957 51.4884 57.376 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M57.376 71.0499C58.4564 71.0499 59.3322 70.1741 59.3322 69.0938C59.3322 68.0135 58.4564 67.1377 57.376 67.1377C56.2957 67.1377 55.4199 68.0135 55.4199 69.0938C55.4199 70.1741 56.2957 71.0499 57.376 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M57.376 74.962C58.4564 74.962 59.3322 74.0863 59.3322 73.0059C59.3322 71.9256 58.4564 71.0498 57.376 71.0498C56.2957 71.0498 55.4199 71.9256 55.4199 73.0059C55.4199 74.0863 56.2957 74.962 57.376 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M57.376 78.8741C58.4564 78.8741 59.3322 77.9984 59.3322 76.918C59.3322 75.8377 58.4564 74.9619 57.376 74.9619C56.2957 74.9619 55.4199 75.8377 55.4199 76.918C55.4199 77.9984 56.2957 78.8741 57.376 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M57.376 90.6114C58.4564 90.6114 59.3322 89.7357 59.3322 88.6553C59.3322 87.575 58.4564 86.6992 57.376 86.6992C56.2957 86.6992 55.4199 87.575 55.4199 88.6553C55.4199 89.7357 56.2957 90.6114 57.376 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M57.376 94.5236C58.4564 94.5236 59.3322 93.6478 59.3322 92.5674C59.3322 91.4871 58.4564 90.6113 57.376 90.6113C56.2957 90.6113 55.4199 91.4871 55.4199 92.5674C55.4199 93.6478 56.2957 94.5236 57.376 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M57.376 102.348C58.4564 102.348 59.3322 101.472 59.3322 100.392C59.3322 99.3113 58.4564 98.4355 57.376 98.4355C56.2957 98.4355 55.4199 99.3113 55.4199 100.392C55.4199 101.472 56.2957 102.348 57.376 102.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M57.376 106.26C58.4564 106.26 59.3322 105.384 59.3322 104.304C59.3322 103.223 58.4564 102.348 57.376 102.348C56.2957 102.348 55.4199 103.223 55.4199 104.304C55.4199 105.384 56.2957 106.26 57.376 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M57.376 110.172C58.4564 110.172 59.3322 109.296 59.3322 108.216C59.3322 107.136 58.4564 106.26 57.376 106.26C56.2957 106.26 55.4199 107.136 55.4199 108.216C55.4199 109.296 56.2957 110.172 57.376 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M57.376 121.909C58.4564 121.909 59.3322 121.034 59.3322 119.953C59.3322 118.873 58.4564 117.997 57.376 117.997C56.2957 117.997 55.4199 118.873 55.4199 119.953C55.4199 121.034 56.2957 121.909 57.376 121.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M57.376 133.646C58.4564 133.646 59.3322 132.77 59.3322 131.69C59.3322 130.609 58.4564 129.733 57.376 129.733C56.2957 129.733 55.4199 130.609 55.4199 131.69C55.4199 132.77 56.2957 133.646 57.376 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M57.376 137.558C58.4564 137.558 59.3322 136.682 59.3322 135.602C59.3322 134.521 58.4564 133.646 57.376 133.646C56.2957 133.646 55.4199 134.521 55.4199 135.602C55.4199 136.682 56.2957 137.558 57.376 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M61.2881 4.54211C62.3685 4.54211 63.2443 3.66633 63.2443 2.586C63.2443 1.50567 62.3685 0.629883 61.2881 0.629883C60.2078 0.629883 59.332 1.50567 59.332 2.586C59.332 3.66633 60.2078 4.54211 61.2881 4.54211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M61.2881 8.45422C62.3685 8.45422 63.2443 7.57844 63.2443 6.49811C63.2443 5.41777 62.3685 4.54199 61.2881 4.54199C60.2078 4.54199 59.332 5.41777 59.332 6.49811C59.332 7.57844 60.2078 8.45422 61.2881 8.45422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M61.2881 12.3663C62.3685 12.3663 63.2443 11.4905 63.2443 10.4102C63.2443 9.32988 62.3685 8.4541 61.2881 8.4541C60.2078 8.4541 59.332 9.32988 59.332 10.4102C59.332 11.4905 60.2078 12.3663 61.2881 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M61.2881 31.9279C62.3685 31.9279 63.2443 31.0521 63.2443 29.9717C63.2443 28.8914 62.3685 28.0156 61.2881 28.0156C60.2078 28.0156 59.332 28.8914 59.332 29.9717C59.332 31.0521 60.2078 31.9279 61.2881 31.9279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M61.2881 47.5763C62.3685 47.5763 63.2443 46.7005 63.2443 45.6202C63.2443 44.5398 62.3685 43.6641 61.2881 43.6641C60.2078 43.6641 59.332 44.5398 59.332 45.6202C59.332 46.7005 60.2078 47.5763 61.2881 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M61.2881 51.4884C62.3685 51.4884 63.2443 50.6126 63.2443 49.5323C63.2443 48.452 62.3685 47.5762 61.2881 47.5762C60.2078 47.5762 59.332 48.452 59.332 49.5323C59.332 50.6126 60.2078 51.4884 61.2881 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M61.2881 55.4015C62.3685 55.4015 63.2443 54.5257 63.2443 53.4454C63.2443 52.365 62.3685 51.4893 61.2881 51.4893C60.2078 51.4893 59.332 52.365 59.332 53.4454C59.332 54.5257 60.2078 55.4015 61.2881 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M61.2881 63.2257C62.3685 63.2257 63.2443 62.3499 63.2443 61.2696C63.2443 60.1893 62.3685 59.3135 61.2881 59.3135C60.2078 59.3135 59.332 60.1893 59.332 61.2696C59.332 62.3499 60.2078 63.2257 61.2881 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M61.2881 71.0499C62.3685 71.0499 63.2443 70.1741 63.2443 69.0938C63.2443 68.0135 62.3685 67.1377 61.2881 67.1377C60.2078 67.1377 59.332 68.0135 59.332 69.0938C59.332 70.1741 60.2078 71.0499 61.2881 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M61.2881 74.962C62.3685 74.962 63.2443 74.0863 63.2443 73.0059C63.2443 71.9256 62.3685 71.0498 61.2881 71.0498C60.2078 71.0498 59.332 71.9256 59.332 73.0059C59.332 74.0863 60.2078 74.962 61.2881 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M61.2881 78.8741C62.3685 78.8741 63.2443 77.9984 63.2443 76.918C63.2443 75.8377 62.3685 74.9619 61.2881 74.9619C60.2078 74.9619 59.332 75.8377 59.332 76.918C59.332 77.9984 60.2078 78.8741 61.2881 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M61.2881 82.7863C62.3685 82.7863 63.2443 81.9105 63.2443 80.8301C63.2443 79.7498 62.3685 78.874 61.2881 78.874C60.2078 78.874 59.332 79.7498 59.332 80.8301C59.332 81.9105 60.2078 82.7863 61.2881 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M61.2881 86.6993C62.3685 86.6993 63.2443 85.8236 63.2443 84.7432C63.2443 83.6629 62.3685 82.7871 61.2881 82.7871C60.2078 82.7871 59.332 83.6629 59.332 84.7432C59.332 85.8236 60.2078 86.6993 61.2881 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M61.2881 90.6114C62.3685 90.6114 63.2443 89.7357 63.2443 88.6553C63.2443 87.575 62.3685 86.6992 61.2881 86.6992C60.2078 86.6992 59.332 87.575 59.332 88.6553C59.332 89.7357 60.2078 90.6114 61.2881 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M61.2881 94.5236C62.3685 94.5236 63.2443 93.6478 63.2443 92.5674C63.2443 91.4871 62.3685 90.6113 61.2881 90.6113C60.2078 90.6113 59.332 91.4871 59.332 92.5674C59.332 93.6478 60.2078 94.5236 61.2881 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M61.2881 106.26C62.3685 106.26 63.2443 105.384 63.2443 104.304C63.2443 103.223 62.3685 102.348 61.2881 102.348C60.2078 102.348 59.332 103.223 59.332 104.304C59.332 105.384 60.2078 106.26 61.2881 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M61.2881 117.997C62.3685 117.997 63.2443 117.121 63.2443 116.041C63.2443 114.961 62.3685 114.085 61.2881 114.085C60.2078 114.085 59.332 114.961 59.332 116.041C59.332 117.121 60.2078 117.997 61.2881 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M61.2881 121.909C62.3685 121.909 63.2443 121.034 63.2443 119.953C63.2443 118.873 62.3685 117.997 61.2881 117.997C60.2078 117.997 59.332 118.873 59.332 119.953C59.332 121.034 60.2078 121.909 61.2881 121.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M61.2881 137.558C62.3685 137.558 63.2443 136.682 63.2443 135.602C63.2443 134.521 62.3685 133.646 61.2881 133.646C60.2078 133.646 59.332 134.521 59.332 135.602C59.332 136.682 60.2078 137.558 61.2881 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M61.2881 141.47C62.3685 141.47 63.2443 140.594 63.2443 139.514C63.2443 138.433 62.3685 137.558 61.2881 137.558C60.2078 137.558 59.332 138.433 59.332 139.514C59.332 140.594 60.2078 141.47 61.2881 141.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M65.2012 12.3663C66.2816 12.3663 67.1573 11.4905 67.1573 10.4102C67.1573 9.32988 66.2816 8.4541 65.2012 8.4541C64.1209 8.4541 63.2451 9.32988 63.2451 10.4102C63.2451 11.4905 64.1209 12.3663 65.2012 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M65.2012 16.2784C66.2816 16.2784 67.1573 15.4027 67.1573 14.3223C67.1573 13.242 66.2816 12.3662 65.2012 12.3662C64.1209 12.3662 63.2451 13.242 63.2451 14.3223C63.2451 15.4027 64.1209 16.2784 65.2012 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M65.2012 20.1905C66.2816 20.1905 67.1573 19.3148 67.1573 18.2344C67.1573 17.1541 66.2816 16.2783 65.2012 16.2783C64.1209 16.2783 63.2451 17.1541 63.2451 18.2344C63.2451 19.3148 64.1209 20.1905 65.2012 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M65.2012 24.1036C66.2816 24.1036 67.1573 23.2279 67.1573 22.1475C67.1573 21.0672 66.2816 20.1914 65.2012 20.1914C64.1209 20.1914 63.2451 21.0672 63.2451 22.1475C63.2451 23.2279 64.1209 24.1036 65.2012 24.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M65.2012 28.0157C66.2816 28.0157 67.1573 27.14 67.1573 26.0596C67.1573 24.9793 66.2816 24.1035 65.2012 24.1035C64.1209 24.1035 63.2451 24.9793 63.2451 26.0596C63.2451 27.14 64.1209 28.0157 65.2012 28.0157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M65.2012 43.6642C66.2816 43.6642 67.1573 42.7884 67.1573 41.7081C67.1573 40.6277 66.2816 39.752 65.2012 39.752C64.1209 39.752 63.2451 40.6277 63.2451 41.7081C63.2451 42.7884 64.1209 43.6642 65.2012 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M65.2012 51.4884C66.2816 51.4884 67.1573 50.6126 67.1573 49.5323C67.1573 48.452 66.2816 47.5762 65.2012 47.5762C64.1209 47.5762 63.2451 48.452 63.2451 49.5323C63.2451 50.6126 64.1209 51.4884 65.2012 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M65.2012 55.4015C66.2816 55.4015 67.1573 54.5257 67.1573 53.4454C67.1573 52.365 66.2816 51.4893 65.2012 51.4893C64.1209 51.4893 63.2451 52.365 63.2451 53.4454C63.2451 54.5257 64.1209 55.4015 65.2012 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M65.2012 59.3136C66.2816 59.3136 67.1573 58.4378 67.1573 57.3575C67.1573 56.2771 66.2816 55.4014 65.2012 55.4014C64.1209 55.4014 63.2451 56.2771 63.2451 57.3575C63.2451 58.4378 64.1209 59.3136 65.2012 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M65.2012 63.2257C66.2816 63.2257 67.1573 62.3499 67.1573 61.2696C67.1573 60.1893 66.2816 59.3135 65.2012 59.3135C64.1209 59.3135 63.2451 60.1893 63.2451 61.2696C63.2451 62.3499 64.1209 63.2257 65.2012 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M65.2012 71.0499C66.2816 71.0499 67.1573 70.1741 67.1573 69.0938C67.1573 68.0135 66.2816 67.1377 65.2012 67.1377C64.1209 67.1377 63.2451 68.0135 63.2451 69.0938C63.2451 70.1741 64.1209 71.0499 65.2012 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M65.2012 86.6993C66.2816 86.6993 67.1573 85.8236 67.1573 84.7432C67.1573 83.6629 66.2816 82.7871 65.2012 82.7871C64.1209 82.7871 63.2451 83.6629 63.2451 84.7432C63.2451 85.8236 64.1209 86.6993 65.2012 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M65.2012 110.172C66.2816 110.172 67.1573 109.296 67.1573 108.216C67.1573 107.136 66.2816 106.26 65.2012 106.26C64.1209 106.26 63.2451 107.136 63.2451 108.216C63.2451 109.296 64.1209 110.172 65.2012 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M65.2012 117.997C66.2816 117.997 67.1573 117.121 67.1573 116.041C67.1573 114.961 66.2816 114.085 65.2012 114.085C64.1209 114.085 63.2451 114.961 63.2451 116.041C63.2451 117.121 64.1209 117.997 65.2012 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M65.2012 121.909C66.2816 121.909 67.1573 121.034 67.1573 119.953C67.1573 118.873 66.2816 117.997 65.2012 117.997C64.1209 117.997 63.2451 118.873 63.2451 119.953C63.2451 121.034 64.1209 121.909 65.2012 121.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M65.2012 125.821C66.2816 125.821 67.1573 124.946 67.1573 123.865C67.1573 122.785 66.2816 121.909 65.2012 121.909C64.1209 121.909 63.2451 122.785 63.2451 123.865C63.2451 124.946 64.1209 125.821 65.2012 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M65.2012 133.646C66.2816 133.646 67.1573 132.77 67.1573 131.69C67.1573 130.609 66.2816 129.733 65.2012 129.733C64.1209 129.733 63.2451 130.609 63.2451 131.69C63.2451 132.77 64.1209 133.646 65.2012 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M65.2012 137.558C66.2816 137.558 67.1573 136.682 67.1573 135.602C67.1573 134.521 66.2816 133.646 65.2012 133.646C64.1209 133.646 63.2451 134.521 63.2451 135.602C63.2451 136.682 64.1209 137.558 65.2012 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M65.2012 145.382C66.2816 145.382 67.1573 144.506 67.1573 143.426C67.1573 142.346 66.2816 141.47 65.2012 141.47C64.1209 141.47 63.2451 142.346 63.2451 143.426C63.2451 144.506 64.1209 145.382 65.2012 145.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M69.1124 16.2784C70.1927 16.2784 71.0685 15.4027 71.0685 14.3223C71.0685 13.242 70.1927 12.3662 69.1124 12.3662C68.032 12.3662 67.1562 13.242 67.1562 14.3223C67.1562 15.4027 68.032 16.2784 69.1124 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M69.1124 20.1905C70.1927 20.1905 71.0685 19.3148 71.0685 18.2344C71.0685 17.1541 70.1927 16.2783 69.1124 16.2783C68.032 16.2783 67.1562 17.1541 67.1562 18.2344C67.1562 19.3148 68.032 20.1905 69.1124 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M69.1124 24.1036C70.1927 24.1036 71.0685 23.2279 71.0685 22.1475C71.0685 21.0672 70.1927 20.1914 69.1124 20.1914C68.032 20.1914 67.1562 21.0672 67.1562 22.1475C67.1562 23.2279 68.032 24.1036 69.1124 24.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M69.1124 31.9279C70.1927 31.9279 71.0685 31.0521 71.0685 29.9717C71.0685 28.8914 70.1927 28.0156 69.1124 28.0156C68.032 28.0156 67.1562 28.8914 67.1562 29.9717C67.1562 31.0521 68.032 31.9279 69.1124 31.9279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M69.1124 35.84C70.1927 35.84 71.0685 34.9642 71.0685 33.8838C71.0685 32.8035 70.1927 31.9277 69.1124 31.9277C68.032 31.9277 67.1562 32.8035 67.1562 33.8838C67.1562 34.9642 68.032 35.84 69.1124 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M69.1124 43.6642C70.1927 43.6642 71.0685 42.7884 71.0685 41.7081C71.0685 40.6277 70.1927 39.752 69.1124 39.752C68.032 39.752 67.1562 40.6277 67.1562 41.7081C67.1562 42.7884 68.032 43.6642 69.1124 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M69.1124 47.5763C70.1927 47.5763 71.0685 46.7005 71.0685 45.6202C71.0685 44.5398 70.1927 43.6641 69.1124 43.6641C68.032 43.6641 67.1562 44.5398 67.1562 45.6202C67.1562 46.7005 68.032 47.5763 69.1124 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M69.1124 51.4884C70.1927 51.4884 71.0685 50.6126 71.0685 49.5323C71.0685 48.452 70.1927 47.5762 69.1124 47.5762C68.032 47.5762 67.1562 48.452 67.1562 49.5323C67.1562 50.6126 68.032 51.4884 69.1124 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M69.1124 55.4015C70.1927 55.4015 71.0685 54.5257 71.0685 53.4454C71.0685 52.365 70.1927 51.4893 69.1124 51.4893C68.032 51.4893 67.1562 52.365 67.1562 53.4454C67.1562 54.5257 68.032 55.4015 69.1124 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M69.1124 59.3136C70.1927 59.3136 71.0685 58.4378 71.0685 57.3575C71.0685 56.2771 70.1927 55.4014 69.1124 55.4014C68.032 55.4014 67.1562 56.2771 67.1562 57.3575C67.1562 58.4378 68.032 59.3136 69.1124 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M69.1124 67.1378C70.1927 67.1378 71.0685 66.262 71.0685 65.1817C71.0685 64.1014 70.1927 63.2256 69.1124 63.2256C68.032 63.2256 67.1562 64.1014 67.1562 65.1817C67.1562 66.262 68.032 67.1378 69.1124 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M69.1124 71.0499C70.1927 71.0499 71.0685 70.1741 71.0685 69.0938C71.0685 68.0135 70.1927 67.1377 69.1124 67.1377C68.032 67.1377 67.1562 68.0135 67.1562 69.0938C67.1562 70.1741 68.032 71.0499 69.1124 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M69.1124 74.962C70.1927 74.962 71.0685 74.0863 71.0685 73.0059C71.0685 71.9256 70.1927 71.0498 69.1124 71.0498C68.032 71.0498 67.1562 71.9256 67.1562 73.0059C67.1562 74.0863 68.032 74.962 69.1124 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M69.1124 86.6993C70.1927 86.6993 71.0685 85.8236 71.0685 84.7432C71.0685 83.6629 70.1927 82.7871 69.1124 82.7871C68.032 82.7871 67.1562 83.6629 67.1562 84.7432C67.1562 85.8236 68.032 86.6993 69.1124 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M69.1124 90.6114C70.1927 90.6114 71.0685 89.7357 71.0685 88.6553C71.0685 87.575 70.1927 86.6992 69.1124 86.6992C68.032 86.6992 67.1562 87.575 67.1562 88.6553C67.1562 89.7357 68.032 90.6114 69.1124 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M69.1124 94.5236C70.1927 94.5236 71.0685 93.6478 71.0685 92.5674C71.0685 91.4871 70.1927 90.6113 69.1124 90.6113C68.032 90.6113 67.1562 91.4871 67.1562 92.5674C67.1562 93.6478 68.032 94.5236 69.1124 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M69.1124 98.4357C70.1927 98.4357 71.0685 97.5599 71.0685 96.4796C71.0685 95.3992 70.1927 94.5234 69.1124 94.5234C68.032 94.5234 67.1562 95.3992 67.1562 96.4796C67.1562 97.5599 68.032 98.4357 69.1124 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M69.1124 102.348C70.1927 102.348 71.0685 101.472 71.0685 100.392C71.0685 99.3113 70.1927 98.4355 69.1124 98.4355C68.032 98.4355 67.1562 99.3113 67.1562 100.392C67.1562 101.472 68.032 102.348 69.1124 102.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M69.1124 106.26C70.1927 106.26 71.0685 105.384 71.0685 104.304C71.0685 103.223 70.1927 102.348 69.1124 102.348C68.032 102.348 67.1562 103.223 67.1562 104.304C67.1562 105.384 68.032 106.26 69.1124 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M69.1124 110.172C70.1927 110.172 71.0685 109.296 71.0685 108.216C71.0685 107.136 70.1927 106.26 69.1124 106.26C68.032 106.26 67.1562 107.136 67.1562 108.216C67.1562 109.296 68.032 110.172 69.1124 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M69.1124 114.084C70.1927 114.084 71.0685 113.208 71.0685 112.128C71.0685 111.048 70.1927 110.172 69.1124 110.172C68.032 110.172 67.1562 111.048 67.1562 112.128C67.1562 113.208 68.032 114.084 69.1124 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M69.1124 125.821C70.1927 125.821 71.0685 124.946 71.0685 123.865C71.0685 122.785 70.1927 121.909 69.1124 121.909C68.032 121.909 67.1562 122.785 67.1562 123.865C67.1562 124.946 68.032 125.821 69.1124 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M69.1124 129.734C70.1927 129.734 71.0685 128.858 71.0685 127.777C71.0685 126.697 70.1927 125.821 69.1124 125.821C68.032 125.821 67.1562 126.697 67.1562 127.777C67.1562 128.858 68.032 129.734 69.1124 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M73.0245 12.3663C74.1048 12.3663 74.9806 11.4905 74.9806 10.4102C74.9806 9.32988 74.1048 8.4541 73.0245 8.4541C71.9441 8.4541 71.0684 9.32988 71.0684 10.4102C71.0684 11.4905 71.9441 12.3663 73.0245 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M73.0245 28.0157C74.1048 28.0157 74.9806 27.14 74.9806 26.0596C74.9806 24.9793 74.1048 24.1035 73.0245 24.1035C71.9441 24.1035 71.0684 24.9793 71.0684 26.0596C71.0684 27.14 71.9441 28.0157 73.0245 28.0157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M73.0245 35.84C74.1048 35.84 74.9806 34.9642 74.9806 33.8838C74.9806 32.8035 74.1048 31.9277 73.0245 31.9277C71.9441 31.9277 71.0684 32.8035 71.0684 33.8838C71.0684 34.9642 71.9441 35.84 73.0245 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M73.0245 39.7521C74.1048 39.7521 74.9806 38.8763 74.9806 37.796C74.9806 36.7156 74.1048 35.8398 73.0245 35.8398C71.9441 35.8398 71.0684 36.7156 71.0684 37.796C71.0684 38.8763 71.9441 39.7521 73.0245 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M73.0245 43.6642C74.1048 43.6642 74.9806 42.7884 74.9806 41.7081C74.9806 40.6277 74.1048 39.752 73.0245 39.752C71.9441 39.752 71.0684 40.6277 71.0684 41.7081C71.0684 42.7884 71.9441 43.6642 73.0245 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M73.0245 51.4884C74.1048 51.4884 74.9806 50.6126 74.9806 49.5323C74.9806 48.452 74.1048 47.5762 73.0245 47.5762C71.9441 47.5762 71.0684 48.452 71.0684 49.5323C71.0684 50.6126 71.9441 51.4884 73.0245 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M73.0245 67.1378C74.1048 67.1378 74.9806 66.262 74.9806 65.1817C74.9806 64.1014 74.1048 63.2256 73.0245 63.2256C71.9441 63.2256 71.0684 64.1014 71.0684 65.1817C71.0684 66.262 71.9441 67.1378 73.0245 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M73.0245 74.962C74.1048 74.962 74.9806 74.0863 74.9806 73.0059C74.9806 71.9256 74.1048 71.0498 73.0245 71.0498C71.9441 71.0498 71.0684 71.9256 71.0684 73.0059C71.0684 74.0863 71.9441 74.962 73.0245 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M73.0245 82.7863C74.1048 82.7863 74.9806 81.9105 74.9806 80.8301C74.9806 79.7498 74.1048 78.874 73.0245 78.874C71.9441 78.874 71.0684 79.7498 71.0684 80.8301C71.0684 81.9105 71.9441 82.7863 73.0245 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M73.0245 94.5236C74.1048 94.5236 74.9806 93.6478 74.9806 92.5674C74.9806 91.4871 74.1048 90.6113 73.0245 90.6113C71.9441 90.6113 71.0684 91.4871 71.0684 92.5674C71.0684 93.6478 71.9441 94.5236 73.0245 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M73.0245 98.4357C74.1048 98.4357 74.9806 97.5599 74.9806 96.4796C74.9806 95.3992 74.1048 94.5234 73.0245 94.5234C71.9441 94.5234 71.0684 95.3992 71.0684 96.4796C71.0684 97.5599 71.9441 98.4357 73.0245 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M73.0245 110.172C74.1048 110.172 74.9806 109.296 74.9806 108.216C74.9806 107.136 74.1048 106.26 73.0245 106.26C71.9441 106.26 71.0684 107.136 71.0684 108.216C71.0684 109.296 71.9441 110.172 73.0245 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M73.0245 125.821C74.1048 125.821 74.9806 124.946 74.9806 123.865C74.9806 122.785 74.1048 121.909 73.0245 121.909C71.9441 121.909 71.0684 122.785 71.0684 123.865C71.0684 124.946 71.9441 125.821 73.0245 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M73.0245 133.646C74.1048 133.646 74.9806 132.77 74.9806 131.69C74.9806 130.609 74.1048 129.733 73.0245 129.733C71.9441 129.733 71.0684 130.609 71.0684 131.69C71.0684 132.77 71.9441 133.646 73.0245 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M73.0245 137.558C74.1048 137.558 74.9806 136.682 74.9806 135.602C74.9806 134.521 74.1048 133.646 73.0245 133.646C71.9441 133.646 71.0684 134.521 71.0684 135.602C71.0684 136.682 71.9441 137.558 73.0245 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M76.9376 8.45422C78.0179 8.45422 78.8937 7.57844 78.8937 6.49811C78.8937 5.41777 78.0179 4.54199 76.9376 4.54199C75.8572 4.54199 74.9814 5.41777 74.9814 6.49811C74.9814 7.57844 75.8572 8.45422 76.9376 8.45422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M76.9376 12.3663C78.0179 12.3663 78.8937 11.4905 78.8937 10.4102C78.8937 9.32988 78.0179 8.4541 76.9376 8.4541C75.8572 8.4541 74.9814 9.32988 74.9814 10.4102C74.9814 11.4905 75.8572 12.3663 76.9376 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M76.9376 16.2784C78.0179 16.2784 78.8937 15.4027 78.8937 14.3223C78.8937 13.242 78.0179 12.3662 76.9376 12.3662C75.8572 12.3662 74.9814 13.242 74.9814 14.3223C74.9814 15.4027 75.8572 16.2784 76.9376 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M76.9376 39.7521C78.0179 39.7521 78.8937 38.8763 78.8937 37.796C78.8937 36.7156 78.0179 35.8398 76.9376 35.8398C75.8572 35.8398 74.9814 36.7156 74.9814 37.796C74.9814 38.8763 75.8572 39.7521 76.9376 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M76.9376 43.6642C78.0179 43.6642 78.8937 42.7884 78.8937 41.7081C78.8937 40.6277 78.0179 39.752 76.9376 39.752C75.8572 39.752 74.9814 40.6277 74.9814 41.7081C74.9814 42.7884 75.8572 43.6642 76.9376 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M76.9376 63.2257C78.0179 63.2257 78.8937 62.3499 78.8937 61.2696C78.8937 60.1893 78.0179 59.3135 76.9376 59.3135C75.8572 59.3135 74.9814 60.1893 74.9814 61.2696C74.9814 62.3499 75.8572 63.2257 76.9376 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M76.9376 67.1378C78.0179 67.1378 78.8937 66.262 78.8937 65.1817C78.8937 64.1014 78.0179 63.2256 76.9376 63.2256C75.8572 63.2256 74.9814 64.1014 74.9814 65.1817C74.9814 66.262 75.8572 67.1378 76.9376 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M76.9376 82.7863C78.0179 82.7863 78.8937 81.9105 78.8937 80.8301C78.8937 79.7498 78.0179 78.874 76.9376 78.874C75.8572 78.874 74.9814 79.7498 74.9814 80.8301C74.9814 81.9105 75.8572 82.7863 76.9376 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M76.9376 86.6993C78.0179 86.6993 78.8937 85.8236 78.8937 84.7432C78.8937 83.6629 78.0179 82.7871 76.9376 82.7871C75.8572 82.7871 74.9814 83.6629 74.9814 84.7432C74.9814 85.8236 75.8572 86.6993 76.9376 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M76.9376 90.6114C78.0179 90.6114 78.8937 89.7357 78.8937 88.6553C78.8937 87.575 78.0179 86.6992 76.9376 86.6992C75.8572 86.6992 74.9814 87.575 74.9814 88.6553C74.9814 89.7357 75.8572 90.6114 76.9376 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M76.9376 94.5236C78.0179 94.5236 78.8937 93.6478 78.8937 92.5674C78.8937 91.4871 78.0179 90.6113 76.9376 90.6113C75.8572 90.6113 74.9814 91.4871 74.9814 92.5674C74.9814 93.6478 75.8572 94.5236 76.9376 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M76.9376 98.4357C78.0179 98.4357 78.8937 97.5599 78.8937 96.4796C78.8937 95.3992 78.0179 94.5234 76.9376 94.5234C75.8572 94.5234 74.9814 95.3992 74.9814 96.4796C74.9814 97.5599 75.8572 98.4357 76.9376 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M76.9376 106.26C78.0179 106.26 78.8937 105.384 78.8937 104.304C78.8937 103.223 78.0179 102.348 76.9376 102.348C75.8572 102.348 74.9814 103.223 74.9814 104.304C74.9814 105.384 75.8572 106.26 76.9376 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M76.9376 125.821C78.0179 125.821 78.8937 124.946 78.8937 123.865C78.8937 122.785 78.0179 121.909 76.9376 121.909C75.8572 121.909 74.9814 122.785 74.9814 123.865C74.9814 124.946 75.8572 125.821 76.9376 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M76.9376 137.558C78.0179 137.558 78.8937 136.682 78.8937 135.602C78.8937 134.521 78.0179 133.646 76.9376 133.646C75.8572 133.646 74.9814 134.521 74.9814 135.602C74.9814 136.682 75.8572 137.558 76.9376 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M76.9376 145.382C78.0179 145.382 78.8937 144.506 78.8937 143.426C78.8937 142.346 78.0179 141.47 76.9376 141.47C75.8572 141.47 74.9814 142.346 74.9814 143.426C74.9814 144.506 75.8572 145.382 76.9376 145.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M80.8477 4.54211C81.928 4.54211 82.8038 3.66633 82.8038 2.586C82.8038 1.50567 81.928 0.629883 80.8477 0.629883C79.7674 0.629883 78.8916 1.50567 78.8916 2.586C78.8916 3.66633 79.7674 4.54211 80.8477 4.54211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M80.8477 8.45422C81.928 8.45422 82.8038 7.57844 82.8038 6.49811C82.8038 5.41777 81.928 4.54199 80.8477 4.54199C79.7674 4.54199 78.8916 5.41777 78.8916 6.49811C78.8916 7.57844 79.7674 8.45422 80.8477 8.45422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M80.8477 16.2784C81.928 16.2784 82.8038 15.4027 82.8038 14.3223C82.8038 13.242 81.928 12.3662 80.8477 12.3662C79.7674 12.3662 78.8916 13.242 78.8916 14.3223C78.8916 15.4027 79.7674 16.2784 80.8477 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M80.8477 24.1036C81.928 24.1036 82.8038 23.2279 82.8038 22.1475C82.8038 21.0672 81.928 20.1914 80.8477 20.1914C79.7674 20.1914 78.8916 21.0672 78.8916 22.1475C78.8916 23.2279 79.7674 24.1036 80.8477 24.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M80.8477 28.0157C81.928 28.0157 82.8038 27.14 82.8038 26.0596C82.8038 24.9793 81.928 24.1035 80.8477 24.1035C79.7674 24.1035 78.8916 24.9793 78.8916 26.0596C78.8916 27.14 79.7674 28.0157 80.8477 28.0157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M80.8477 31.9279C81.928 31.9279 82.8038 31.0521 82.8038 29.9717C82.8038 28.8914 81.928 28.0156 80.8477 28.0156C79.7674 28.0156 78.8916 28.8914 78.8916 29.9717C78.8916 31.0521 79.7674 31.9279 80.8477 31.9279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M80.8477 35.84C81.928 35.84 82.8038 34.9642 82.8038 33.8838C82.8038 32.8035 81.928 31.9277 80.8477 31.9277C79.7674 31.9277 78.8916 32.8035 78.8916 33.8838C78.8916 34.9642 79.7674 35.84 80.8477 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M80.8477 39.7521C81.928 39.7521 82.8038 38.8763 82.8038 37.796C82.8038 36.7156 81.928 35.8398 80.8477 35.8398C79.7674 35.8398 78.8916 36.7156 78.8916 37.796C78.8916 38.8763 79.7674 39.7521 80.8477 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M80.8477 43.6642C81.928 43.6642 82.8038 42.7884 82.8038 41.7081C82.8038 40.6277 81.928 39.752 80.8477 39.752C79.7674 39.752 78.8916 40.6277 78.8916 41.7081C78.8916 42.7884 79.7674 43.6642 80.8477 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M80.8477 55.4015C81.928 55.4015 82.8038 54.5257 82.8038 53.4454C82.8038 52.365 81.928 51.4893 80.8477 51.4893C79.7674 51.4893 78.8916 52.365 78.8916 53.4454C78.8916 54.5257 79.7674 55.4015 80.8477 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M80.8477 63.2257C81.928 63.2257 82.8038 62.3499 82.8038 61.2696C82.8038 60.1893 81.928 59.3135 80.8477 59.3135C79.7674 59.3135 78.8916 60.1893 78.8916 61.2696C78.8916 62.3499 79.7674 63.2257 80.8477 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M80.8477 74.962C81.928 74.962 82.8038 74.0863 82.8038 73.0059C82.8038 71.9256 81.928 71.0498 80.8477 71.0498C79.7674 71.0498 78.8916 71.9256 78.8916 73.0059C78.8916 74.0863 79.7674 74.962 80.8477 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M80.8477 82.7863C81.928 82.7863 82.8038 81.9105 82.8038 80.8301C82.8038 79.7498 81.928 78.874 80.8477 78.874C79.7674 78.874 78.8916 79.7498 78.8916 80.8301C78.8916 81.9105 79.7674 82.7863 80.8477 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M80.8477 86.6993C81.928 86.6993 82.8038 85.8236 82.8038 84.7432C82.8038 83.6629 81.928 82.7871 80.8477 82.7871C79.7674 82.7871 78.8916 83.6629 78.8916 84.7432C78.8916 85.8236 79.7674 86.6993 80.8477 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M80.8477 90.6114C81.928 90.6114 82.8038 89.7357 82.8038 88.6553C82.8038 87.575 81.928 86.6992 80.8477 86.6992C79.7674 86.6992 78.8916 87.575 78.8916 88.6553C78.8916 89.7357 79.7674 90.6114 80.8477 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M80.8477 98.4357C81.928 98.4357 82.8038 97.5599 82.8038 96.4796C82.8038 95.3992 81.928 94.5234 80.8477 94.5234C79.7674 94.5234 78.8916 95.3992 78.8916 96.4796C78.8916 97.5599 79.7674 98.4357 80.8477 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M80.8477 110.172C81.928 110.172 82.8038 109.296 82.8038 108.216C82.8038 107.136 81.928 106.26 80.8477 106.26C79.7674 106.26 78.8916 107.136 78.8916 108.216C78.8916 109.296 79.7674 110.172 80.8477 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M80.8477 117.997C81.928 117.997 82.8038 117.121 82.8038 116.041C82.8038 114.961 81.928 114.085 80.8477 114.085C79.7674 114.085 78.8916 114.961 78.8916 116.041C78.8916 117.121 79.7674 117.997 80.8477 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M80.8477 121.909C81.928 121.909 82.8038 121.034 82.8038 119.953C82.8038 118.873 81.928 117.997 80.8477 117.997C79.7674 117.997 78.8916 118.873 78.8916 119.953C78.8916 121.034 79.7674 121.909 80.8477 121.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M80.8477 137.558C81.928 137.558 82.8038 136.682 82.8038 135.602C82.8038 134.521 81.928 133.646 80.8477 133.646C79.7674 133.646 78.8916 134.521 78.8916 135.602C78.8916 136.682 79.7674 137.558 80.8477 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M84.7618 12.3663C85.8421 12.3663 86.7179 11.4905 86.7179 10.4102C86.7179 9.32988 85.8421 8.4541 84.7618 8.4541C83.6814 8.4541 82.8057 9.32988 82.8057 10.4102C82.8057 11.4905 83.6814 12.3663 84.7618 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M84.7618 16.2784C85.8421 16.2784 86.7179 15.4027 86.7179 14.3223C86.7179 13.242 85.8421 12.3662 84.7618 12.3662C83.6814 12.3662 82.8057 13.242 82.8057 14.3223C82.8057 15.4027 83.6814 16.2784 84.7618 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M84.7618 35.84C85.8421 35.84 86.7179 34.9642 86.7179 33.8838C86.7179 32.8035 85.8421 31.9277 84.7618 31.9277C83.6814 31.9277 82.8057 32.8035 82.8057 33.8838C82.8057 34.9642 83.6814 35.84 84.7618 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M84.7618 39.7521C85.8421 39.7521 86.7179 38.8763 86.7179 37.796C86.7179 36.7156 85.8421 35.8398 84.7618 35.8398C83.6814 35.8398 82.8057 36.7156 82.8057 37.796C82.8057 38.8763 83.6814 39.7521 84.7618 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M84.7618 51.4884C85.8421 51.4884 86.7179 50.6126 86.7179 49.5323C86.7179 48.452 85.8421 47.5762 84.7618 47.5762C83.6814 47.5762 82.8057 48.452 82.8057 49.5323C82.8057 50.6126 83.6814 51.4884 84.7618 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M84.7618 55.4015C85.8421 55.4015 86.7179 54.5257 86.7179 53.4454C86.7179 52.365 85.8421 51.4893 84.7618 51.4893C83.6814 51.4893 82.8057 52.365 82.8057 53.4454C82.8057 54.5257 83.6814 55.4015 84.7618 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M84.7618 67.1378C85.8421 67.1378 86.7179 66.262 86.7179 65.1817C86.7179 64.1014 85.8421 63.2256 84.7618 63.2256C83.6814 63.2256 82.8057 64.1014 82.8057 65.1817C82.8057 66.262 83.6814 67.1378 84.7618 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M84.7618 71.0499C85.8421 71.0499 86.7179 70.1741 86.7179 69.0938C86.7179 68.0135 85.8421 67.1377 84.7618 67.1377C83.6814 67.1377 82.8057 68.0135 82.8057 69.0938C82.8057 70.1741 83.6814 71.0499 84.7618 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M84.7618 82.7863C85.8421 82.7863 86.7179 81.9105 86.7179 80.8301C86.7179 79.7498 85.8421 78.874 84.7618 78.874C83.6814 78.874 82.8057 79.7498 82.8057 80.8301C82.8057 81.9105 83.6814 82.7863 84.7618 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M84.7618 94.5236C85.8421 94.5236 86.7179 93.6478 86.7179 92.5674C86.7179 91.4871 85.8421 90.6113 84.7618 90.6113C83.6814 90.6113 82.8057 91.4871 82.8057 92.5674C82.8057 93.6478 83.6814 94.5236 84.7618 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M84.7618 102.348C85.8421 102.348 86.7179 101.472 86.7179 100.392C86.7179 99.3113 85.8421 98.4355 84.7618 98.4355C83.6814 98.4355 82.8057 99.3113 82.8057 100.392C82.8057 101.472 83.6814 102.348 84.7618 102.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M84.7618 110.172C85.8421 110.172 86.7179 109.296 86.7179 108.216C86.7179 107.136 85.8421 106.26 84.7618 106.26C83.6814 106.26 82.8057 107.136 82.8057 108.216C82.8057 109.296 83.6814 110.172 84.7618 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M84.7618 117.997C85.8421 117.997 86.7179 117.121 86.7179 116.041C86.7179 114.961 85.8421 114.085 84.7618 114.085C83.6814 114.085 82.8057 114.961 82.8057 116.041C82.8057 117.121 83.6814 117.997 84.7618 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M84.7618 129.734C85.8421 129.734 86.7179 128.858 86.7179 127.777C86.7179 126.697 85.8421 125.821 84.7618 125.821C83.6814 125.821 82.8057 126.697 82.8057 127.777C82.8057 128.858 83.6814 129.734 84.7618 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M84.7618 133.646C85.8421 133.646 86.7179 132.77 86.7179 131.69C86.7179 130.609 85.8421 129.733 84.7618 129.733C83.6814 129.733 82.8057 130.609 82.8057 131.69C82.8057 132.77 83.6814 133.646 84.7618 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M84.7618 137.558C85.8421 137.558 86.7179 136.682 86.7179 135.602C86.7179 134.521 85.8421 133.646 84.7618 133.646C83.6814 133.646 82.8057 134.521 82.8057 135.602C82.8057 136.682 83.6814 137.558 84.7618 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M88.6739 12.3663C89.7542 12.3663 90.63 11.4905 90.63 10.4102C90.63 9.32988 89.7542 8.4541 88.6739 8.4541C87.5936 8.4541 86.7178 9.32988 86.7178 10.4102C86.7178 11.4905 87.5936 12.3663 88.6739 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M88.6739 16.2784C89.7542 16.2784 90.63 15.4027 90.63 14.3223C90.63 13.242 89.7542 12.3662 88.6739 12.3662C87.5936 12.3662 86.7178 13.242 86.7178 14.3223C86.7178 15.4027 87.5936 16.2784 88.6739 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M88.6739 24.1036C89.7542 24.1036 90.63 23.2279 90.63 22.1475C90.63 21.0672 89.7542 20.1914 88.6739 20.1914C87.5936 20.1914 86.7178 21.0672 86.7178 22.1475C86.7178 23.2279 87.5936 24.1036 88.6739 24.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M88.6739 28.0157C89.7542 28.0157 90.63 27.14 90.63 26.0596C90.63 24.9793 89.7542 24.1035 88.6739 24.1035C87.5936 24.1035 86.7178 24.9793 86.7178 26.0596C86.7178 27.14 87.5936 28.0157 88.6739 28.0157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M88.6739 31.9279C89.7542 31.9279 90.63 31.0521 90.63 29.9717C90.63 28.8914 89.7542 28.0156 88.6739 28.0156C87.5936 28.0156 86.7178 28.8914 86.7178 29.9717C86.7178 31.0521 87.5936 31.9279 88.6739 31.9279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M88.6739 39.7521C89.7542 39.7521 90.63 38.8763 90.63 37.796C90.63 36.7156 89.7542 35.8398 88.6739 35.8398C87.5936 35.8398 86.7178 36.7156 86.7178 37.796C86.7178 38.8763 87.5936 39.7521 88.6739 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M88.6739 43.6642C89.7542 43.6642 90.63 42.7884 90.63 41.7081C90.63 40.6277 89.7542 39.752 88.6739 39.752C87.5936 39.752 86.7178 40.6277 86.7178 41.7081C86.7178 42.7884 87.5936 43.6642 88.6739 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M88.6739 51.4884C89.7542 51.4884 90.63 50.6126 90.63 49.5323C90.63 48.452 89.7542 47.5762 88.6739 47.5762C87.5936 47.5762 86.7178 48.452 86.7178 49.5323C86.7178 50.6126 87.5936 51.4884 88.6739 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M88.6739 63.2257C89.7542 63.2257 90.63 62.3499 90.63 61.2696C90.63 60.1893 89.7542 59.3135 88.6739 59.3135C87.5936 59.3135 86.7178 60.1893 86.7178 61.2696C86.7178 62.3499 87.5936 63.2257 88.6739 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M88.6739 74.962C89.7542 74.962 90.63 74.0863 90.63 73.0059C90.63 71.9256 89.7542 71.0498 88.6739 71.0498C87.5936 71.0498 86.7178 71.9256 86.7178 73.0059C86.7178 74.0863 87.5936 74.962 88.6739 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M88.6739 86.6993C89.7542 86.6993 90.63 85.8236 90.63 84.7432C90.63 83.6629 89.7542 82.7871 88.6739 82.7871C87.5936 82.7871 86.7178 83.6629 86.7178 84.7432C86.7178 85.8236 87.5936 86.6993 88.6739 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M88.6739 94.5236C89.7542 94.5236 90.63 93.6478 90.63 92.5674C90.63 91.4871 89.7542 90.6113 88.6739 90.6113C87.5936 90.6113 86.7178 91.4871 86.7178 92.5674C86.7178 93.6478 87.5936 94.5236 88.6739 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M88.6739 98.4357C89.7542 98.4357 90.63 97.5599 90.63 96.4796C90.63 95.3992 89.7542 94.5234 88.6739 94.5234C87.5936 94.5234 86.7178 95.3992 86.7178 96.4796C86.7178 97.5599 87.5936 98.4357 88.6739 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M88.6739 110.172C89.7542 110.172 90.63 109.296 90.63 108.216C90.63 107.136 89.7542 106.26 88.6739 106.26C87.5936 106.26 86.7178 107.136 86.7178 108.216C86.7178 109.296 87.5936 110.172 88.6739 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M88.6739 114.084C89.7542 114.084 90.63 113.208 90.63 112.128C90.63 111.048 89.7542 110.172 88.6739 110.172C87.5936 110.172 86.7178 111.048 86.7178 112.128C86.7178 113.208 87.5936 114.084 88.6739 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M88.6739 117.997C89.7542 117.997 90.63 117.121 90.63 116.041C90.63 114.961 89.7542 114.085 88.6739 114.085C87.5936 114.085 86.7178 114.961 86.7178 116.041C86.7178 117.121 87.5936 117.997 88.6739 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M88.6739 133.646C89.7542 133.646 90.63 132.77 90.63 131.69C90.63 130.609 89.7542 129.733 88.6739 129.733C87.5936 129.733 86.7178 130.609 86.7178 131.69C86.7178 132.77 87.5936 133.646 88.6739 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M88.6739 137.558C89.7542 137.558 90.63 136.682 90.63 135.602C90.63 134.521 89.7542 133.646 88.6739 133.646C87.5936 133.646 86.7178 134.521 86.7178 135.602C86.7178 136.682 87.5936 137.558 88.6739 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M92.586 12.3663C93.6663 12.3663 94.5421 11.4905 94.5421 10.4102C94.5421 9.32988 93.6663 8.4541 92.586 8.4541C91.5057 8.4541 90.6299 9.32988 90.6299 10.4102C90.6299 11.4905 91.5057 12.3663 92.586 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M92.586 24.1036C93.6663 24.1036 94.5421 23.2279 94.5421 22.1475C94.5421 21.0672 93.6663 20.1914 92.586 20.1914C91.5057 20.1914 90.6299 21.0672 90.6299 22.1475C90.6299 23.2279 91.5057 24.1036 92.586 24.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M92.586 31.9279C93.6663 31.9279 94.5421 31.0521 94.5421 29.9717C94.5421 28.8914 93.6663 28.0156 92.586 28.0156C91.5057 28.0156 90.6299 28.8914 90.6299 29.9717C90.6299 31.0521 91.5057 31.9279 92.586 31.9279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M92.586 35.84C93.6663 35.84 94.5421 34.9642 94.5421 33.8838C94.5421 32.8035 93.6663 31.9277 92.586 31.9277C91.5057 31.9277 90.6299 32.8035 90.6299 33.8838C90.6299 34.9642 91.5057 35.84 92.586 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M92.586 43.6642C93.6663 43.6642 94.5421 42.7884 94.5421 41.7081C94.5421 40.6277 93.6663 39.752 92.586 39.752C91.5057 39.752 90.6299 40.6277 90.6299 41.7081C90.6299 42.7884 91.5057 43.6642 92.586 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M92.586 47.5763C93.6663 47.5763 94.5421 46.7005 94.5421 45.6202C94.5421 44.5398 93.6663 43.6641 92.586 43.6641C91.5057 43.6641 90.6299 44.5398 90.6299 45.6202C90.6299 46.7005 91.5057 47.5763 92.586 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M92.586 51.4884C93.6663 51.4884 94.5421 50.6126 94.5421 49.5323C94.5421 48.452 93.6663 47.5762 92.586 47.5762C91.5057 47.5762 90.6299 48.452 90.6299 49.5323C90.6299 50.6126 91.5057 51.4884 92.586 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M92.586 55.4015C93.6663 55.4015 94.5421 54.5257 94.5421 53.4454C94.5421 52.365 93.6663 51.4893 92.586 51.4893C91.5057 51.4893 90.6299 52.365 90.6299 53.4454C90.6299 54.5257 91.5057 55.4015 92.586 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M92.586 59.3136C93.6663 59.3136 94.5421 58.4378 94.5421 57.3575C94.5421 56.2771 93.6663 55.4014 92.586 55.4014C91.5057 55.4014 90.6299 56.2771 90.6299 57.3575C90.6299 58.4378 91.5057 59.3136 92.586 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M92.586 63.2257C93.6663 63.2257 94.5421 62.3499 94.5421 61.2696C94.5421 60.1893 93.6663 59.3135 92.586 59.3135C91.5057 59.3135 90.6299 60.1893 90.6299 61.2696C90.6299 62.3499 91.5057 63.2257 92.586 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M92.586 67.1378C93.6663 67.1378 94.5421 66.262 94.5421 65.1817C94.5421 64.1014 93.6663 63.2256 92.586 63.2256C91.5057 63.2256 90.6299 64.1014 90.6299 65.1817C90.6299 66.262 91.5057 67.1378 92.586 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M92.586 71.0499C93.6663 71.0499 94.5421 70.1741 94.5421 69.0938C94.5421 68.0135 93.6663 67.1377 92.586 67.1377C91.5057 67.1377 90.6299 68.0135 90.6299 69.0938C90.6299 70.1741 91.5057 71.0499 92.586 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M92.586 74.962C93.6663 74.962 94.5421 74.0863 94.5421 73.0059C94.5421 71.9256 93.6663 71.0498 92.586 71.0498C91.5057 71.0498 90.6299 71.9256 90.6299 73.0059C90.6299 74.0863 91.5057 74.962 92.586 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M92.586 86.6993C93.6663 86.6993 94.5421 85.8236 94.5421 84.7432C94.5421 83.6629 93.6663 82.7871 92.586 82.7871C91.5057 82.7871 90.6299 83.6629 90.6299 84.7432C90.6299 85.8236 91.5057 86.6993 92.586 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M92.586 94.5236C93.6663 94.5236 94.5421 93.6478 94.5421 92.5674C94.5421 91.4871 93.6663 90.6113 92.586 90.6113C91.5057 90.6113 90.6299 91.4871 90.6299 92.5674C90.6299 93.6478 91.5057 94.5236 92.586 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M92.586 114.084C93.6663 114.084 94.5421 113.208 94.5421 112.128C94.5421 111.048 93.6663 110.172 92.586 110.172C91.5057 110.172 90.6299 111.048 90.6299 112.128C90.6299 113.208 91.5057 114.084 92.586 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M92.586 125.821C93.6663 125.821 94.5421 124.946 94.5421 123.865C94.5421 122.785 93.6663 121.909 92.586 121.909C91.5057 121.909 90.6299 122.785 90.6299 123.865C90.6299 124.946 91.5057 125.821 92.586 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M92.586 137.558C93.6663 137.558 94.5421 136.682 94.5421 135.602C94.5421 134.521 93.6663 133.646 92.586 133.646C91.5057 133.646 90.6299 134.521 90.6299 135.602C90.6299 136.682 91.5057 137.558 92.586 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M92.586 145.382C93.6663 145.382 94.5421 144.506 94.5421 143.426C94.5421 142.346 93.6663 141.47 92.586 141.47C91.5057 141.47 90.6299 142.346 90.6299 143.426C90.6299 144.506 91.5057 145.382 92.586 145.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M96.4991 4.54211C97.5794 4.54211 98.4552 3.66633 98.4552 2.586C98.4552 1.50567 97.5794 0.629883 96.4991 0.629883C95.4188 0.629883 94.543 1.50567 94.543 2.586C94.543 3.66633 95.4188 4.54211 96.4991 4.54211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M96.4991 16.2784C97.5794 16.2784 98.4552 15.4027 98.4552 14.3223C98.4552 13.242 97.5794 12.3662 96.4991 12.3662C95.4188 12.3662 94.543 13.242 94.543 14.3223C94.543 15.4027 95.4188 16.2784 96.4991 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M96.4991 20.1905C97.5794 20.1905 98.4552 19.3148 98.4552 18.2344C98.4552 17.1541 97.5794 16.2783 96.4991 16.2783C95.4188 16.2783 94.543 17.1541 94.543 18.2344C94.543 19.3148 95.4188 20.1905 96.4991 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    d: "M96.4991 24.1036C97.5794 24.1036 98.4552 23.2279 98.4552 22.1475C98.4552 21.0672 97.5794 20.1914 96.4991 20.1914C95.4188 20.1914 94.543 21.0672 94.543 22.1475C94.543 23.2279 95.4188 24.1036 96.4991 24.1036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    d: "M96.4991 28.0157C97.5794 28.0157 98.4552 27.14 98.4552 26.0596C98.4552 24.9793 97.5794 24.1035 96.4991 24.1035C95.4188 24.1035 94.543 24.9793 94.543 26.0596C94.543 27.14 95.4188 28.0157 96.4991 28.0157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    d: "M96.4991 35.84C97.5794 35.84 98.4552 34.9642 98.4552 33.8838C98.4552 32.8035 97.5794 31.9277 96.4991 31.9277C95.4188 31.9277 94.543 32.8035 94.543 33.8838C94.543 34.9642 95.4188 35.84 96.4991 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    d: "M96.4991 43.6642C97.5794 43.6642 98.4552 42.7884 98.4552 41.7081C98.4552 40.6277 97.5794 39.752 96.4991 39.752C95.4188 39.752 94.543 40.6277 94.543 41.7081C94.543 42.7884 95.4188 43.6642 96.4991 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    d: "M96.4991 47.5763C97.5794 47.5763 98.4552 46.7005 98.4552 45.6202C98.4552 44.5398 97.5794 43.6641 96.4991 43.6641C95.4188 43.6641 94.543 44.5398 94.543 45.6202C94.543 46.7005 95.4188 47.5763 96.4991 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    d: "M96.4991 51.4884C97.5794 51.4884 98.4552 50.6126 98.4552 49.5323C98.4552 48.452 97.5794 47.5762 96.4991 47.5762C95.4188 47.5762 94.543 48.452 94.543 49.5323C94.543 50.6126 95.4188 51.4884 96.4991 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    d: "M96.4991 55.4015C97.5794 55.4015 98.4552 54.5257 98.4552 53.4454C98.4552 52.365 97.5794 51.4893 96.4991 51.4893C95.4188 51.4893 94.543 52.365 94.543 53.4454C94.543 54.5257 95.4188 55.4015 96.4991 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    d: "M96.4991 67.1378C97.5794 67.1378 98.4552 66.262 98.4552 65.1817C98.4552 64.1014 97.5794 63.2256 96.4991 63.2256C95.4188 63.2256 94.543 64.1014 94.543 65.1817C94.543 66.262 95.4188 67.1378 96.4991 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    d: "M96.4991 74.962C97.5794 74.962 98.4552 74.0863 98.4552 73.0059C98.4552 71.9256 97.5794 71.0498 96.4991 71.0498C95.4188 71.0498 94.543 71.9256 94.543 73.0059C94.543 74.0863 95.4188 74.962 96.4991 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    d: "M96.4991 82.7863C97.5794 82.7863 98.4552 81.9105 98.4552 80.8301C98.4552 79.7498 97.5794 78.874 96.4991 78.874C95.4188 78.874 94.543 79.7498 94.543 80.8301C94.543 81.9105 95.4188 82.7863 96.4991 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    d: "M96.4991 86.6993C97.5794 86.6993 98.4552 85.8236 98.4552 84.7432C98.4552 83.6629 97.5794 82.7871 96.4991 82.7871C95.4188 82.7871 94.543 83.6629 94.543 84.7432C94.543 85.8236 95.4188 86.6993 96.4991 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    d: "M96.4991 90.6114C97.5794 90.6114 98.4552 89.7357 98.4552 88.6553C98.4552 87.575 97.5794 86.6992 96.4991 86.6992C95.4188 86.6992 94.543 87.575 94.543 88.6553C94.543 89.7357 95.4188 90.6114 96.4991 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    d: "M96.4991 98.4357C97.5794 98.4357 98.4552 97.5599 98.4552 96.4796C98.4552 95.3992 97.5794 94.5234 96.4991 94.5234C95.4188 94.5234 94.543 95.3992 94.543 96.4796C94.543 97.5599 95.4188 98.4357 96.4991 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    d: "M96.4991 106.26C97.5794 106.26 98.4552 105.384 98.4552 104.304C98.4552 103.223 97.5794 102.348 96.4991 102.348C95.4188 102.348 94.543 103.223 94.543 104.304C94.543 105.384 95.4188 106.26 96.4991 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    d: "M96.4991 110.172C97.5794 110.172 98.4552 109.296 98.4552 108.216C98.4552 107.136 97.5794 106.26 96.4991 106.26C95.4188 106.26 94.543 107.136 94.543 108.216C94.543 109.296 95.4188 110.172 96.4991 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    d: "M96.4991 114.084C97.5794 114.084 98.4552 113.208 98.4552 112.128C98.4552 111.048 97.5794 110.172 96.4991 110.172C95.4188 110.172 94.543 111.048 94.543 112.128C94.543 113.208 95.4188 114.084 96.4991 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    d: "M96.4991 121.909C97.5794 121.909 98.4552 121.034 98.4552 119.953C98.4552 118.873 97.5794 117.997 96.4991 117.997C95.4188 117.997 94.543 118.873 94.543 119.953C94.543 121.034 95.4188 121.909 96.4991 121.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    d: "M96.4991 125.821C97.5794 125.821 98.4552 124.946 98.4552 123.865C98.4552 122.785 97.5794 121.909 96.4991 121.909C95.4188 121.909 94.543 122.785 94.543 123.865C94.543 124.946 95.4188 125.821 96.4991 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    d: "M96.4991 137.558C97.5794 137.558 98.4552 136.682 98.4552 135.602C98.4552 134.521 97.5794 133.646 96.4991 133.646C95.4188 133.646 94.543 134.521 94.543 135.602C94.543 136.682 95.4188 137.558 96.4991 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    d: "M96.4991 141.47C97.5794 141.47 98.4552 140.594 98.4552 139.514C98.4552 138.433 97.5794 137.558 96.4991 137.558C95.4188 137.558 94.543 138.433 94.543 139.514C94.543 140.594 95.4188 141.47 96.4991 141.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    d: "M100.41 4.54211C101.491 4.54211 102.366 3.66633 102.366 2.586C102.366 1.50567 101.491 0.629883 100.41 0.629883C99.3299 0.629883 98.4541 1.50567 98.4541 2.586C98.4541 3.66633 99.3299 4.54211 100.41 4.54211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    d: "M100.41 16.2784C101.491 16.2784 102.366 15.4027 102.366 14.3223C102.366 13.242 101.491 12.3662 100.41 12.3662C99.3299 12.3662 98.4541 13.242 98.4541 14.3223C98.4541 15.4027 99.3299 16.2784 100.41 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    d: "M100.41 20.1905C101.491 20.1905 102.366 19.3148 102.366 18.2344C102.366 17.1541 101.491 16.2783 100.41 16.2783C99.3299 16.2783 98.4541 17.1541 98.4541 18.2344C98.4541 19.3148 99.3299 20.1905 100.41 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    d: "M100.41 35.84C101.491 35.84 102.366 34.9642 102.366 33.8838C102.366 32.8035 101.491 31.9277 100.41 31.9277C99.3299 31.9277 98.4541 32.8035 98.4541 33.8838C98.4541 34.9642 99.3299 35.84 100.41 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    d: "M100.41 51.4884C101.491 51.4884 102.366 50.6126 102.366 49.5323C102.366 48.452 101.491 47.5762 100.41 47.5762C99.3299 47.5762 98.4541 48.452 98.4541 49.5323C98.4541 50.6126 99.3299 51.4884 100.41 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    d: "M100.41 59.3136C101.491 59.3136 102.366 58.4378 102.366 57.3575C102.366 56.2771 101.491 55.4014 100.41 55.4014C99.3299 55.4014 98.4541 56.2771 98.4541 57.3575C98.4541 58.4378 99.3299 59.3136 100.41 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    d: "M100.41 63.2257C101.491 63.2257 102.366 62.3499 102.366 61.2696C102.366 60.1893 101.491 59.3135 100.41 59.3135C99.3299 59.3135 98.4541 60.1893 98.4541 61.2696C98.4541 62.3499 99.3299 63.2257 100.41 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "M100.41 67.1378C101.491 67.1378 102.366 66.262 102.366 65.1817C102.366 64.1014 101.491 63.2256 100.41 63.2256C99.3299 63.2256 98.4541 64.1014 98.4541 65.1817C98.4541 66.262 99.3299 67.1378 100.41 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    d: "M100.41 71.0499C101.491 71.0499 102.366 70.1741 102.366 69.0938C102.366 68.0135 101.491 67.1377 100.41 67.1377C99.3299 67.1377 98.4541 68.0135 98.4541 69.0938C98.4541 70.1741 99.3299 71.0499 100.41 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "M100.41 82.7863C101.491 82.7863 102.366 81.9105 102.366 80.8301C102.366 79.7498 101.491 78.874 100.41 78.874C99.3299 78.874 98.4541 79.7498 98.4541 80.8301C98.4541 81.9105 99.3299 82.7863 100.41 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    d: "M100.41 90.6114C101.491 90.6114 102.366 89.7357 102.366 88.6553C102.366 87.575 101.491 86.6992 100.41 86.6992C99.3299 86.6992 98.4541 87.575 98.4541 88.6553C98.4541 89.7357 99.3299 90.6114 100.41 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    d: "M100.41 94.5236C101.491 94.5236 102.366 93.6478 102.366 92.5674C102.366 91.4871 101.491 90.6113 100.41 90.6113C99.3299 90.6113 98.4541 91.4871 98.4541 92.5674C98.4541 93.6478 99.3299 94.5236 100.41 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    d: "M100.41 98.4357C101.491 98.4357 102.366 97.5599 102.366 96.4796C102.366 95.3992 101.491 94.5234 100.41 94.5234C99.3299 94.5234 98.4541 95.3992 98.4541 96.4796C98.4541 97.5599 99.3299 98.4357 100.41 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    d: "M100.41 102.348C101.491 102.348 102.366 101.472 102.366 100.392C102.366 99.3113 101.491 98.4355 100.41 98.4355C99.3299 98.4355 98.4541 99.3113 98.4541 100.392C98.4541 101.472 99.3299 102.348 100.41 102.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    d: "M100.41 110.172C101.491 110.172 102.366 109.296 102.366 108.216C102.366 107.136 101.491 106.26 100.41 106.26C99.3299 106.26 98.4541 107.136 98.4541 108.216C98.4541 109.296 99.3299 110.172 100.41 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    d: "M100.41 117.997C101.491 117.997 102.366 117.121 102.366 116.041C102.366 114.961 101.491 114.085 100.41 114.085C99.3299 114.085 98.4541 114.961 98.4541 116.041C98.4541 117.121 99.3299 117.997 100.41 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    d: "M100.41 129.734C101.491 129.734 102.366 128.858 102.366 127.777C102.366 126.697 101.491 125.821 100.41 125.821C99.3299 125.821 98.4541 126.697 98.4541 127.777C98.4541 128.858 99.3299 129.734 100.41 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    d: "M100.41 133.646C101.491 133.646 102.366 132.77 102.366 131.69C102.366 130.609 101.491 129.733 100.41 129.733C99.3299 129.733 98.4541 130.609 98.4541 131.69C98.4541 132.77 99.3299 133.646 100.41 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    d: "M100.41 137.558C101.491 137.558 102.366 136.682 102.366 135.602C102.366 134.521 101.491 133.646 100.41 133.646C99.3299 133.646 98.4541 134.521 98.4541 135.602C98.4541 136.682 99.3299 137.558 100.41 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    d: "M104.323 16.2784C105.404 16.2784 106.279 15.4027 106.279 14.3223C106.279 13.242 105.404 12.3662 104.323 12.3662C103.243 12.3662 102.367 13.242 102.367 14.3223C102.367 15.4027 103.243 16.2784 104.323 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    d: "M104.323 28.0157C105.404 28.0157 106.279 27.14 106.279 26.0596C106.279 24.9793 105.404 24.1035 104.323 24.1035C103.243 24.1035 102.367 24.9793 102.367 26.0596C102.367 27.14 103.243 28.0157 104.323 28.0157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    d: "M104.323 39.7521C105.404 39.7521 106.279 38.8763 106.279 37.796C106.279 36.7156 105.404 35.8398 104.323 35.8398C103.243 35.8398 102.367 36.7156 102.367 37.796C102.367 38.8763 103.243 39.7521 104.323 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    d: "M104.323 43.6642C105.404 43.6642 106.279 42.7884 106.279 41.7081C106.279 40.6277 105.404 39.752 104.323 39.752C103.243 39.752 102.367 40.6277 102.367 41.7081C102.367 42.7884 103.243 43.6642 104.323 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    d: "M104.323 47.5763C105.404 47.5763 106.279 46.7005 106.279 45.6202C106.279 44.5398 105.404 43.6641 104.323 43.6641C103.243 43.6641 102.367 44.5398 102.367 45.6202C102.367 46.7005 103.243 47.5763 104.323 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    d: "M104.323 59.3136C105.404 59.3136 106.279 58.4378 106.279 57.3575C106.279 56.2771 105.404 55.4014 104.323 55.4014C103.243 55.4014 102.367 56.2771 102.367 57.3575C102.367 58.4378 103.243 59.3136 104.323 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    d: "M104.323 67.1378C105.404 67.1378 106.279 66.262 106.279 65.1817C106.279 64.1014 105.404 63.2256 104.323 63.2256C103.243 63.2256 102.367 64.1014 102.367 65.1817C102.367 66.262 103.243 67.1378 104.323 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    d: "M104.323 71.0499C105.404 71.0499 106.279 70.1741 106.279 69.0938C106.279 68.0135 105.404 67.1377 104.323 67.1377C103.243 67.1377 102.367 68.0135 102.367 69.0938C102.367 70.1741 103.243 71.0499 104.323 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    d: "M104.323 74.962C105.404 74.962 106.279 74.0863 106.279 73.0059C106.279 71.9256 105.404 71.0498 104.323 71.0498C103.243 71.0498 102.367 71.9256 102.367 73.0059C102.367 74.0863 103.243 74.962 104.323 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    d: "M104.323 78.8741C105.404 78.8741 106.279 77.9984 106.279 76.918C106.279 75.8377 105.404 74.9619 104.323 74.9619C103.243 74.9619 102.367 75.8377 102.367 76.918C102.367 77.9984 103.243 78.8741 104.323 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    d: "M104.323 82.7863C105.404 82.7863 106.279 81.9105 106.279 80.8301C106.279 79.7498 105.404 78.874 104.323 78.874C103.243 78.874 102.367 79.7498 102.367 80.8301C102.367 81.9105 103.243 82.7863 104.323 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    d: "M104.323 86.6993C105.404 86.6993 106.279 85.8236 106.279 84.7432C106.279 83.6629 105.404 82.7871 104.323 82.7871C103.243 82.7871 102.367 83.6629 102.367 84.7432C102.367 85.8236 103.243 86.6993 104.323 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    d: "M104.323 94.5236C105.404 94.5236 106.279 93.6478 106.279 92.5674C106.279 91.4871 105.404 90.6113 104.323 90.6113C103.243 90.6113 102.367 91.4871 102.367 92.5674C102.367 93.6478 103.243 94.5236 104.323 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    d: "M104.323 98.4357C105.404 98.4357 106.279 97.5599 106.279 96.4796C106.279 95.3992 105.404 94.5234 104.323 94.5234C103.243 94.5234 102.367 95.3992 102.367 96.4796C102.367 97.5599 103.243 98.4357 104.323 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    d: "M104.323 110.172C105.404 110.172 106.279 109.296 106.279 108.216C106.279 107.136 105.404 106.26 104.323 106.26C103.243 106.26 102.367 107.136 102.367 108.216C102.367 109.296 103.243 110.172 104.323 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    d: "M104.323 114.084C105.404 114.084 106.279 113.208 106.279 112.128C106.279 111.048 105.404 110.172 104.323 110.172C103.243 110.172 102.367 111.048 102.367 112.128C102.367 113.208 103.243 114.084 104.323 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    d: "M104.323 117.997C105.404 117.997 106.279 117.121 106.279 116.041C106.279 114.961 105.404 114.085 104.323 114.085C103.243 114.085 102.367 114.961 102.367 116.041C102.367 117.121 103.243 117.997 104.323 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    d: "M104.323 125.821C105.404 125.821 106.279 124.946 106.279 123.865C106.279 122.785 105.404 121.909 104.323 121.909C103.243 121.909 102.367 122.785 102.367 123.865C102.367 124.946 103.243 125.821 104.323 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    d: "M108.233 16.2784C109.314 16.2784 110.19 15.4027 110.19 14.3223C110.19 13.242 109.314 12.3662 108.233 12.3662C107.153 12.3662 106.277 13.242 106.277 14.3223C106.277 15.4027 107.153 16.2784 108.233 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    d: "M108.233 20.1905C109.314 20.1905 110.19 19.3148 110.19 18.2344C110.19 17.1541 109.314 16.2783 108.233 16.2783C107.153 16.2783 106.277 17.1541 106.277 18.2344C106.277 19.3148 107.153 20.1905 108.233 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    d: "M108.233 43.6642C109.314 43.6642 110.19 42.7884 110.19 41.7081C110.19 40.6277 109.314 39.752 108.233 39.752C107.153 39.752 106.277 40.6277 106.277 41.7081C106.277 42.7884 107.153 43.6642 108.233 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    d: "M108.233 51.4884C109.314 51.4884 110.19 50.6126 110.19 49.5323C110.19 48.452 109.314 47.5762 108.233 47.5762C107.153 47.5762 106.277 48.452 106.277 49.5323C106.277 50.6126 107.153 51.4884 108.233 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    d: "M108.233 71.0499C109.314 71.0499 110.19 70.1741 110.19 69.0938C110.19 68.0135 109.314 67.1377 108.233 67.1377C107.153 67.1377 106.277 68.0135 106.277 69.0938C106.277 70.1741 107.153 71.0499 108.233 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    d: "M108.233 78.8741C109.314 78.8741 110.19 77.9984 110.19 76.918C110.19 75.8377 109.314 74.9619 108.233 74.9619C107.153 74.9619 106.277 75.8377 106.277 76.918C106.277 77.9984 107.153 78.8741 108.233 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    d: "M108.233 86.6993C109.314 86.6993 110.19 85.8236 110.19 84.7432C110.19 83.6629 109.314 82.7871 108.233 82.7871C107.153 82.7871 106.277 83.6629 106.277 84.7432C106.277 85.8236 107.153 86.6993 108.233 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    d: "M108.233 90.6114C109.314 90.6114 110.19 89.7357 110.19 88.6553C110.19 87.575 109.314 86.6992 108.233 86.6992C107.153 86.6992 106.277 87.575 106.277 88.6553C106.277 89.7357 107.153 90.6114 108.233 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    d: "M108.233 94.5236C109.314 94.5236 110.19 93.6478 110.19 92.5674C110.19 91.4871 109.314 90.6113 108.233 90.6113C107.153 90.6113 106.277 91.4871 106.277 92.5674C106.277 93.6478 107.153 94.5236 108.233 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    d: "M108.233 98.4357C109.314 98.4357 110.19 97.5599 110.19 96.4796C110.19 95.3992 109.314 94.5234 108.233 94.5234C107.153 94.5234 106.277 95.3992 106.277 96.4796C106.277 97.5599 107.153 98.4357 108.233 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    d: "M108.233 106.26C109.314 106.26 110.19 105.384 110.19 104.304C110.19 103.223 109.314 102.348 108.233 102.348C107.153 102.348 106.277 103.223 106.277 104.304C106.277 105.384 107.153 106.26 108.233 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    d: "M108.233 110.172C109.314 110.172 110.19 109.296 110.19 108.216C110.19 107.136 109.314 106.26 108.233 106.26C107.153 106.26 106.277 107.136 106.277 108.216C106.277 109.296 107.153 110.172 108.233 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    d: "M108.233 121.909C109.314 121.909 110.19 121.034 110.19 119.953C110.19 118.873 109.314 117.997 108.233 117.997C107.153 117.997 106.277 118.873 106.277 119.953C106.277 121.034 107.153 121.909 108.233 121.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    d: "M108.233 129.734C109.314 129.734 110.19 128.858 110.19 127.777C110.19 126.697 109.314 125.821 108.233 125.821C107.153 125.821 106.277 126.697 106.277 127.777C106.277 128.858 107.153 129.734 108.233 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    d: "M108.233 137.558C109.314 137.558 110.19 136.682 110.19 135.602C110.19 134.521 109.314 133.646 108.233 133.646C107.153 133.646 106.277 134.521 106.277 135.602C106.277 136.682 107.153 137.558 108.233 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    d: "M108.233 141.47C109.314 141.47 110.19 140.594 110.19 139.514C110.19 138.433 109.314 137.558 108.233 137.558C107.153 137.558 106.277 138.433 106.277 139.514C106.277 140.594 107.153 141.47 108.233 141.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    d: "M108.233 145.382C109.314 145.382 110.19 144.506 110.19 143.426C110.19 142.346 109.314 141.47 108.233 141.47C107.153 141.47 106.277 142.346 106.277 143.426C106.277 144.506 107.153 145.382 108.233 145.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    d: "M112.148 4.54211C113.228 4.54211 114.104 3.66633 114.104 2.586C114.104 1.50567 113.228 0.629883 112.148 0.629883C111.067 0.629883 110.191 1.50567 110.191 2.586C110.191 3.66633 111.067 4.54211 112.148 4.54211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    d: "M112.148 8.45422C113.228 8.45422 114.104 7.57844 114.104 6.49811C114.104 5.41777 113.228 4.54199 112.148 4.54199C111.067 4.54199 110.191 5.41777 110.191 6.49811C110.191 7.57844 111.067 8.45422 112.148 8.45422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    d: "M112.148 12.3663C113.228 12.3663 114.104 11.4905 114.104 10.4102C114.104 9.32988 113.228 8.4541 112.148 8.4541C111.067 8.4541 110.191 9.32988 110.191 10.4102C110.191 11.4905 111.067 12.3663 112.148 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    d: "M112.148 20.1905C113.228 20.1905 114.104 19.3148 114.104 18.2344C114.104 17.1541 113.228 16.2783 112.148 16.2783C111.067 16.2783 110.191 17.1541 110.191 18.2344C110.191 19.3148 111.067 20.1905 112.148 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    d: "M112.148 28.0157C113.228 28.0157 114.104 27.14 114.104 26.0596C114.104 24.9793 113.228 24.1035 112.148 24.1035C111.067 24.1035 110.191 24.9793 110.191 26.0596C110.191 27.14 111.067 28.0157 112.148 28.0157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    d: "M112.148 35.84C113.228 35.84 114.104 34.9642 114.104 33.8838C114.104 32.8035 113.228 31.9277 112.148 31.9277C111.067 31.9277 110.191 32.8035 110.191 33.8838C110.191 34.9642 111.067 35.84 112.148 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    d: "M112.148 39.7521C113.228 39.7521 114.104 38.8763 114.104 37.796C114.104 36.7156 113.228 35.8398 112.148 35.8398C111.067 35.8398 110.191 36.7156 110.191 37.796C110.191 38.8763 111.067 39.7521 112.148 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    d: "M112.148 43.6642C113.228 43.6642 114.104 42.7884 114.104 41.7081C114.104 40.6277 113.228 39.752 112.148 39.752C111.067 39.752 110.191 40.6277 110.191 41.7081C110.191 42.7884 111.067 43.6642 112.148 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    d: "M112.148 55.4015C113.228 55.4015 114.104 54.5257 114.104 53.4454C114.104 52.365 113.228 51.4893 112.148 51.4893C111.067 51.4893 110.191 52.365 110.191 53.4454C110.191 54.5257 111.067 55.4015 112.148 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    d: "M112.148 71.0499C113.228 71.0499 114.104 70.1741 114.104 69.0938C114.104 68.0135 113.228 67.1377 112.148 67.1377C111.067 67.1377 110.191 68.0135 110.191 69.0938C110.191 70.1741 111.067 71.0499 112.148 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    d: "M112.148 78.8741C113.228 78.8741 114.104 77.9984 114.104 76.918C114.104 75.8377 113.228 74.9619 112.148 74.9619C111.067 74.9619 110.191 75.8377 110.191 76.918C110.191 77.9984 111.067 78.8741 112.148 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    d: "M112.148 82.7863C113.228 82.7863 114.104 81.9105 114.104 80.8301C114.104 79.7498 113.228 78.874 112.148 78.874C111.067 78.874 110.191 79.7498 110.191 80.8301C110.191 81.9105 111.067 82.7863 112.148 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    d: "M112.148 86.6993C113.228 86.6993 114.104 85.8236 114.104 84.7432C114.104 83.6629 113.228 82.7871 112.148 82.7871C111.067 82.7871 110.191 83.6629 110.191 84.7432C110.191 85.8236 111.067 86.6993 112.148 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    d: "M112.148 90.6114C113.228 90.6114 114.104 89.7357 114.104 88.6553C114.104 87.575 113.228 86.6992 112.148 86.6992C111.067 86.6992 110.191 87.575 110.191 88.6553C110.191 89.7357 111.067 90.6114 112.148 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    d: "M112.148 114.084C113.228 114.084 114.104 113.208 114.104 112.128C114.104 111.048 113.228 110.172 112.148 110.172C111.067 110.172 110.191 111.048 110.191 112.128C110.191 113.208 111.067 114.084 112.148 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    d: "M112.148 117.997C113.228 117.997 114.104 117.121 114.104 116.041C114.104 114.961 113.228 114.085 112.148 114.085C111.067 114.085 110.191 114.961 110.191 116.041C110.191 117.121 111.067 117.997 112.148 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    d: "M112.148 121.909C113.228 121.909 114.104 121.034 114.104 119.953C114.104 118.873 113.228 117.997 112.148 117.997C111.067 117.997 110.191 118.873 110.191 119.953C110.191 121.034 111.067 121.909 112.148 121.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    d: "M112.148 125.821C113.228 125.821 114.104 124.946 114.104 123.865C114.104 122.785 113.228 121.909 112.148 121.909C111.067 121.909 110.191 122.785 110.191 123.865C110.191 124.946 111.067 125.821 112.148 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    d: "M112.148 129.734C113.228 129.734 114.104 128.858 114.104 127.777C114.104 126.697 113.228 125.821 112.148 125.821C111.067 125.821 110.191 126.697 110.191 127.777C110.191 128.858 111.067 129.734 112.148 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    d: "M112.148 137.558C113.228 137.558 114.104 136.682 114.104 135.602C114.104 134.521 113.228 133.646 112.148 133.646C111.067 133.646 110.191 134.521 110.191 135.602C110.191 136.682 111.067 137.558 112.148 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    d: "M112.148 141.47C113.228 141.47 114.104 140.594 114.104 139.514C114.104 138.433 113.228 137.558 112.148 137.558C111.067 137.558 110.191 138.433 110.191 139.514C110.191 140.594 111.067 141.47 112.148 141.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    d: "M112.148 145.382C113.228 145.382 114.104 144.506 114.104 143.426C114.104 142.346 113.228 141.47 112.148 141.47C111.067 141.47 110.191 142.346 110.191 143.426C110.191 144.506 111.067 145.382 112.148 145.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    d: "M116.06 35.84C117.14 35.84 118.016 34.9642 118.016 33.8838C118.016 32.8035 117.14 31.9277 116.06 31.9277C114.979 31.9277 114.104 32.8035 114.104 33.8838C114.104 34.9642 114.979 35.84 116.06 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    d: "M116.06 39.7521C117.14 39.7521 118.016 38.8763 118.016 37.796C118.016 36.7156 117.14 35.8398 116.06 35.8398C114.979 35.8398 114.104 36.7156 114.104 37.796C114.104 38.8763 114.979 39.7521 116.06 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    d: "M116.06 51.4884C117.14 51.4884 118.016 50.6126 118.016 49.5323C118.016 48.452 117.14 47.5762 116.06 47.5762C114.979 47.5762 114.104 48.452 114.104 49.5323C114.104 50.6126 114.979 51.4884 116.06 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    d: "M116.06 55.4015C117.14 55.4015 118.016 54.5257 118.016 53.4454C118.016 52.365 117.14 51.4893 116.06 51.4893C114.979 51.4893 114.104 52.365 114.104 53.4454C114.104 54.5257 114.979 55.4015 116.06 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    d: "M116.06 59.3136C117.14 59.3136 118.016 58.4378 118.016 57.3575C118.016 56.2771 117.14 55.4014 116.06 55.4014C114.979 55.4014 114.104 56.2771 114.104 57.3575C114.104 58.4378 114.979 59.3136 116.06 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    d: "M116.06 71.0499C117.14 71.0499 118.016 70.1741 118.016 69.0938C118.016 68.0135 117.14 67.1377 116.06 67.1377C114.979 67.1377 114.104 68.0135 114.104 69.0938C114.104 70.1741 114.979 71.0499 116.06 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    d: "M116.06 74.962C117.14 74.962 118.016 74.0863 118.016 73.0059C118.016 71.9256 117.14 71.0498 116.06 71.0498C114.979 71.0498 114.104 71.9256 114.104 73.0059C114.104 74.0863 114.979 74.962 116.06 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    d: "M116.06 78.8741C117.14 78.8741 118.016 77.9984 118.016 76.918C118.016 75.8377 117.14 74.9619 116.06 74.9619C114.979 74.9619 114.104 75.8377 114.104 76.918C114.104 77.9984 114.979 78.8741 116.06 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    d: "M116.06 82.7863C117.14 82.7863 118.016 81.9105 118.016 80.8301C118.016 79.7498 117.14 78.874 116.06 78.874C114.979 78.874 114.104 79.7498 114.104 80.8301C114.104 81.9105 114.979 82.7863 116.06 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    d: "M116.06 94.5236C117.14 94.5236 118.016 93.6478 118.016 92.5674C118.016 91.4871 117.14 90.6113 116.06 90.6113C114.979 90.6113 114.104 91.4871 114.104 92.5674C114.104 93.6478 114.979 94.5236 116.06 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    d: "M116.06 102.348C117.14 102.348 118.016 101.472 118.016 100.392C118.016 99.3113 117.14 98.4355 116.06 98.4355C114.979 98.4355 114.104 99.3113 114.104 100.392C114.104 101.472 114.979 102.348 116.06 102.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_484",
    d: "M116.06 114.084C117.14 114.084 118.016 113.208 118.016 112.128C118.016 111.048 117.14 110.172 116.06 110.172C114.979 110.172 114.104 111.048 114.104 112.128C114.104 113.208 114.979 114.084 116.06 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_485",
    d: "M116.06 129.734C117.14 129.734 118.016 128.858 118.016 127.777C118.016 126.697 117.14 125.821 116.06 125.821C114.979 125.821 114.104 126.697 114.104 127.777C114.104 128.858 114.979 129.734 116.06 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_486",
    d: "M116.06 133.646C117.14 133.646 118.016 132.77 118.016 131.69C118.016 130.609 117.14 129.733 116.06 129.733C114.979 129.733 114.104 130.609 114.104 131.69C114.104 132.77 114.979 133.646 116.06 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_487",
    d: "M116.06 141.47C117.14 141.47 118.016 140.594 118.016 139.514C118.016 138.433 117.14 137.558 116.06 137.558C114.979 137.558 114.104 138.433 114.104 139.514C114.104 140.594 114.979 141.47 116.06 141.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_488",
    d: "M119.972 39.7521C121.052 39.7521 121.928 38.8763 121.928 37.796C121.928 36.7156 121.052 35.8398 119.972 35.8398C118.891 35.8398 118.016 36.7156 118.016 37.796C118.016 38.8763 118.891 39.7521 119.972 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_489",
    d: "M119.972 43.6642C121.052 43.6642 121.928 42.7884 121.928 41.7081C121.928 40.6277 121.052 39.752 119.972 39.752C118.891 39.752 118.016 40.6277 118.016 41.7081C118.016 42.7884 118.891 43.6642 119.972 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_490",
    d: "M119.972 51.4884C121.052 51.4884 121.928 50.6126 121.928 49.5323C121.928 48.452 121.052 47.5762 119.972 47.5762C118.891 47.5762 118.016 48.452 118.016 49.5323C118.016 50.6126 118.891 51.4884 119.972 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_491",
    d: "M119.972 55.4015C121.052 55.4015 121.928 54.5257 121.928 53.4454C121.928 52.365 121.052 51.4893 119.972 51.4893C118.891 51.4893 118.016 52.365 118.016 53.4454C118.016 54.5257 118.891 55.4015 119.972 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_492",
    d: "M119.972 59.3136C121.052 59.3136 121.928 58.4378 121.928 57.3575C121.928 56.2771 121.052 55.4014 119.972 55.4014C118.891 55.4014 118.016 56.2771 118.016 57.3575C118.016 58.4378 118.891 59.3136 119.972 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_493",
    d: "M119.972 63.2257C121.052 63.2257 121.928 62.3499 121.928 61.2696C121.928 60.1893 121.052 59.3135 119.972 59.3135C118.891 59.3135 118.016 60.1893 118.016 61.2696C118.016 62.3499 118.891 63.2257 119.972 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_494",
    d: "M119.972 67.1378C121.052 67.1378 121.928 66.262 121.928 65.1817C121.928 64.1014 121.052 63.2256 119.972 63.2256C118.891 63.2256 118.016 64.1014 118.016 65.1817C118.016 66.262 118.891 67.1378 119.972 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_495",
    d: "M119.972 71.0499C121.052 71.0499 121.928 70.1741 121.928 69.0938C121.928 68.0135 121.052 67.1377 119.972 67.1377C118.891 67.1377 118.016 68.0135 118.016 69.0938C118.016 70.1741 118.891 71.0499 119.972 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_496",
    d: "M119.972 82.7863C121.052 82.7863 121.928 81.9105 121.928 80.8301C121.928 79.7498 121.052 78.874 119.972 78.874C118.891 78.874 118.016 79.7498 118.016 80.8301C118.016 81.9105 118.891 82.7863 119.972 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_497",
    d: "M119.972 90.6114C121.052 90.6114 121.928 89.7357 121.928 88.6553C121.928 87.575 121.052 86.6992 119.972 86.6992C118.891 86.6992 118.016 87.575 118.016 88.6553C118.016 89.7357 118.891 90.6114 119.972 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_498",
    d: "M119.972 94.5236C121.052 94.5236 121.928 93.6478 121.928 92.5674C121.928 91.4871 121.052 90.6113 119.972 90.6113C118.891 90.6113 118.016 91.4871 118.016 92.5674C118.016 93.6478 118.891 94.5236 119.972 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_499",
    d: "M119.972 114.084C121.052 114.084 121.928 113.208 121.928 112.128C121.928 111.048 121.052 110.172 119.972 110.172C118.891 110.172 118.016 111.048 118.016 112.128C118.016 113.208 118.891 114.084 119.972 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_500",
    d: "M119.972 121.909C121.052 121.909 121.928 121.034 121.928 119.953C121.928 118.873 121.052 117.997 119.972 117.997C118.891 117.997 118.016 118.873 118.016 119.953C118.016 121.034 118.891 121.909 119.972 121.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_501",
    d: "M119.972 129.734C121.052 129.734 121.928 128.858 121.928 127.777C121.928 126.697 121.052 125.821 119.972 125.821C118.891 125.821 118.016 126.697 118.016 127.777C118.016 128.858 118.891 129.734 119.972 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_502",
    d: "M119.972 133.646C121.052 133.646 121.928 132.77 121.928 131.69C121.928 130.609 121.052 129.733 119.972 129.733C118.891 129.733 118.016 130.609 118.016 131.69C118.016 132.77 118.891 133.646 119.972 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_503",
    d: "M119.972 137.558C121.052 137.558 121.928 136.682 121.928 135.602C121.928 134.521 121.052 133.646 119.972 133.646C118.891 133.646 118.016 134.521 118.016 135.602C118.016 136.682 118.891 137.558 119.972 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_504",
    d: "M123.883 47.5763C124.963 47.5763 125.839 46.7005 125.839 45.6202C125.839 44.5398 124.963 43.6641 123.883 43.6641C122.803 43.6641 121.927 44.5398 121.927 45.6202C121.927 46.7005 122.803 47.5763 123.883 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_505",
    d: "M123.883 51.4884C124.963 51.4884 125.839 50.6126 125.839 49.5323C125.839 48.452 124.963 47.5762 123.883 47.5762C122.803 47.5762 121.927 48.452 121.927 49.5323C121.927 50.6126 122.803 51.4884 123.883 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_506",
    d: "M123.883 55.4015C124.963 55.4015 125.839 54.5257 125.839 53.4454C125.839 52.365 124.963 51.4893 123.883 51.4893C122.803 51.4893 121.927 52.365 121.927 53.4454C121.927 54.5257 122.803 55.4015 123.883 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_507",
    d: "M123.883 59.3136C124.963 59.3136 125.839 58.4378 125.839 57.3575C125.839 56.2771 124.963 55.4014 123.883 55.4014C122.803 55.4014 121.927 56.2771 121.927 57.3575C121.927 58.4378 122.803 59.3136 123.883 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_508",
    d: "M123.883 63.2257C124.963 63.2257 125.839 62.3499 125.839 61.2696C125.839 60.1893 124.963 59.3135 123.883 59.3135C122.803 59.3135 121.927 60.1893 121.927 61.2696C121.927 62.3499 122.803 63.2257 123.883 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_509",
    d: "M123.883 71.0499C124.963 71.0499 125.839 70.1741 125.839 69.0938C125.839 68.0135 124.963 67.1377 123.883 67.1377C122.803 67.1377 121.927 68.0135 121.927 69.0938C121.927 70.1741 122.803 71.0499 123.883 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_510",
    d: "M123.883 74.962C124.963 74.962 125.839 74.0863 125.839 73.0059C125.839 71.9256 124.963 71.0498 123.883 71.0498C122.803 71.0498 121.927 71.9256 121.927 73.0059C121.927 74.0863 122.803 74.962 123.883 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_511",
    d: "M123.883 82.7863C124.963 82.7863 125.839 81.9105 125.839 80.8301C125.839 79.7498 124.963 78.874 123.883 78.874C122.803 78.874 121.927 79.7498 121.927 80.8301C121.927 81.9105 122.803 82.7863 123.883 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_512",
    d: "M123.883 86.6993C124.963 86.6993 125.839 85.8236 125.839 84.7432C125.839 83.6629 124.963 82.7871 123.883 82.7871C122.803 82.7871 121.927 83.6629 121.927 84.7432C121.927 85.8236 122.803 86.6993 123.883 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_513",
    d: "M123.883 94.5236C124.963 94.5236 125.839 93.6478 125.839 92.5674C125.839 91.4871 124.963 90.6113 123.883 90.6113C122.803 90.6113 121.927 91.4871 121.927 92.5674C121.927 93.6478 122.803 94.5236 123.883 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_514",
    d: "M123.883 106.26C124.963 106.26 125.839 105.384 125.839 104.304C125.839 103.223 124.963 102.348 123.883 102.348C122.803 102.348 121.927 103.223 121.927 104.304C121.927 105.384 122.803 106.26 123.883 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_515",
    d: "M123.883 110.172C124.963 110.172 125.839 109.296 125.839 108.216C125.839 107.136 124.963 106.26 123.883 106.26C122.803 106.26 121.927 107.136 121.927 108.216C121.927 109.296 122.803 110.172 123.883 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_516",
    d: "M123.883 114.084C124.963 114.084 125.839 113.208 125.839 112.128C125.839 111.048 124.963 110.172 123.883 110.172C122.803 110.172 121.927 111.048 121.927 112.128C121.927 113.208 122.803 114.084 123.883 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_517",
    d: "M123.883 129.734C124.963 129.734 125.839 128.858 125.839 127.777C125.839 126.697 124.963 125.821 123.883 125.821C122.803 125.821 121.927 126.697 121.927 127.777C121.927 128.858 122.803 129.734 123.883 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_518",
    d: "M123.883 137.558C124.963 137.558 125.839 136.682 125.839 135.602C125.839 134.521 124.963 133.646 123.883 133.646C122.803 133.646 121.927 134.521 121.927 135.602C121.927 136.682 122.803 137.558 123.883 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_519",
    d: "M127.796 35.84C128.876 35.84 129.752 34.9642 129.752 33.8838C129.752 32.8035 128.876 31.9277 127.796 31.9277C126.716 31.9277 125.84 32.8035 125.84 33.8838C125.84 34.9642 126.716 35.84 127.796 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_520",
    d: "M127.796 39.7521C128.876 39.7521 129.752 38.8763 129.752 37.796C129.752 36.7156 128.876 35.8398 127.796 35.8398C126.716 35.8398 125.84 36.7156 125.84 37.796C125.84 38.8763 126.716 39.7521 127.796 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_521",
    d: "M127.796 47.5763C128.876 47.5763 129.752 46.7005 129.752 45.6202C129.752 44.5398 128.876 43.6641 127.796 43.6641C126.716 43.6641 125.84 44.5398 125.84 45.6202C125.84 46.7005 126.716 47.5763 127.796 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_522",
    d: "M127.796 63.2257C128.876 63.2257 129.752 62.3499 129.752 61.2696C129.752 60.1893 128.876 59.3135 127.796 59.3135C126.716 59.3135 125.84 60.1893 125.84 61.2696C125.84 62.3499 126.716 63.2257 127.796 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_523",
    d: "M127.796 74.962C128.876 74.962 129.752 74.0863 129.752 73.0059C129.752 71.9256 128.876 71.0498 127.796 71.0498C126.716 71.0498 125.84 71.9256 125.84 73.0059C125.84 74.0863 126.716 74.962 127.796 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_524",
    d: "M127.796 78.8741C128.876 78.8741 129.752 77.9984 129.752 76.918C129.752 75.8377 128.876 74.9619 127.796 74.9619C126.716 74.9619 125.84 75.8377 125.84 76.918C125.84 77.9984 126.716 78.8741 127.796 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_525",
    d: "M127.796 82.7863C128.876 82.7863 129.752 81.9105 129.752 80.8301C129.752 79.7498 128.876 78.874 127.796 78.874C126.716 78.874 125.84 79.7498 125.84 80.8301C125.84 81.9105 126.716 82.7863 127.796 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_526",
    d: "M127.796 114.084C128.876 114.084 129.752 113.208 129.752 112.128C129.752 111.048 128.876 110.172 127.796 110.172C126.716 110.172 125.84 111.048 125.84 112.128C125.84 113.208 126.716 114.084 127.796 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_527",
    d: "M127.796 117.997C128.876 117.997 129.752 117.121 129.752 116.041C129.752 114.961 128.876 114.085 127.796 114.085C126.716 114.085 125.84 114.961 125.84 116.041C125.84 117.121 126.716 117.997 127.796 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_528",
    d: "M127.796 121.909C128.876 121.909 129.752 121.034 129.752 119.953C129.752 118.873 128.876 117.997 127.796 117.997C126.716 117.997 125.84 118.873 125.84 119.953C125.84 121.034 126.716 121.909 127.796 121.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_529",
    d: "M127.796 125.821C128.876 125.821 129.752 124.946 129.752 123.865C129.752 122.785 128.876 121.909 127.796 121.909C126.716 121.909 125.84 122.785 125.84 123.865C125.84 124.946 126.716 125.821 127.796 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_530",
    d: "M127.796 129.734C128.876 129.734 129.752 128.858 129.752 127.777C129.752 126.697 128.876 125.821 127.796 125.821C126.716 125.821 125.84 126.697 125.84 127.777C125.84 128.858 126.716 129.734 127.796 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_531",
    d: "M127.796 133.646C128.876 133.646 129.752 132.77 129.752 131.69C129.752 130.609 128.876 129.733 127.796 129.733C126.716 129.733 125.84 130.609 125.84 131.69C125.84 132.77 126.716 133.646 127.796 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_532",
    d: "M127.796 137.558C128.876 137.558 129.752 136.682 129.752 135.602C129.752 134.521 128.876 133.646 127.796 133.646C126.716 133.646 125.84 134.521 125.84 135.602C125.84 136.682 126.716 137.558 127.796 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_533",
    d: "M127.796 145.382C128.876 145.382 129.752 144.506 129.752 143.426C129.752 142.346 128.876 141.47 127.796 141.47C126.716 141.47 125.84 142.346 125.84 143.426C125.84 144.506 126.716 145.382 127.796 145.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_534",
    d: "M131.709 47.5763C132.789 47.5763 133.665 46.7005 133.665 45.6202C133.665 44.5398 132.789 43.6641 131.709 43.6641C130.629 43.6641 129.753 44.5398 129.753 45.6202C129.753 46.7005 130.629 47.5763 131.709 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_535",
    d: "M131.709 51.4884C132.789 51.4884 133.665 50.6126 133.665 49.5323C133.665 48.452 132.789 47.5762 131.709 47.5762C130.629 47.5762 129.753 48.452 129.753 49.5323C129.753 50.6126 130.629 51.4884 131.709 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_536",
    d: "M131.709 59.3136C132.789 59.3136 133.665 58.4378 133.665 57.3575C133.665 56.2771 132.789 55.4014 131.709 55.4014C130.629 55.4014 129.753 56.2771 129.753 57.3575C129.753 58.4378 130.629 59.3136 131.709 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_537",
    d: "M131.709 67.1378C132.789 67.1378 133.665 66.262 133.665 65.1817C133.665 64.1014 132.789 63.2256 131.709 63.2256C130.629 63.2256 129.753 64.1014 129.753 65.1817C129.753 66.262 130.629 67.1378 131.709 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_538",
    d: "M131.709 78.8741C132.789 78.8741 133.665 77.9984 133.665 76.918C133.665 75.8377 132.789 74.9619 131.709 74.9619C130.629 74.9619 129.753 75.8377 129.753 76.918C129.753 77.9984 130.629 78.8741 131.709 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_539",
    d: "M131.709 86.6993C132.789 86.6993 133.665 85.8236 133.665 84.7432C133.665 83.6629 132.789 82.7871 131.709 82.7871C130.629 82.7871 129.753 83.6629 129.753 84.7432C129.753 85.8236 130.629 86.6993 131.709 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_540",
    d: "M131.709 94.5236C132.789 94.5236 133.665 93.6478 133.665 92.5674C133.665 91.4871 132.789 90.6113 131.709 90.6113C130.629 90.6113 129.753 91.4871 129.753 92.5674C129.753 93.6478 130.629 94.5236 131.709 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_541",
    d: "M131.709 98.4357C132.789 98.4357 133.665 97.5599 133.665 96.4796C133.665 95.3992 132.789 94.5234 131.709 94.5234C130.629 94.5234 129.753 95.3992 129.753 96.4796C129.753 97.5599 130.629 98.4357 131.709 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_542",
    d: "M131.709 102.348C132.789 102.348 133.665 101.472 133.665 100.392C133.665 99.3113 132.789 98.4355 131.709 98.4355C130.629 98.4355 129.753 99.3113 129.753 100.392C129.753 101.472 130.629 102.348 131.709 102.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_543",
    d: "M131.709 114.084C132.789 114.084 133.665 113.208 133.665 112.128C133.665 111.048 132.789 110.172 131.709 110.172C130.629 110.172 129.753 111.048 129.753 112.128C129.753 113.208 130.629 114.084 131.709 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_544",
    d: "M131.709 121.909C132.789 121.909 133.665 121.034 133.665 119.953C133.665 118.873 132.789 117.997 131.709 117.997C130.629 117.997 129.753 118.873 129.753 119.953C129.753 121.034 130.629 121.909 131.709 121.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_545",
    d: "M131.709 133.646C132.789 133.646 133.665 132.77 133.665 131.69C133.665 130.609 132.789 129.733 131.709 129.733C130.629 129.733 129.753 130.609 129.753 131.69C129.753 132.77 130.629 133.646 131.709 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_546",
    d: "M131.709 137.558C132.789 137.558 133.665 136.682 133.665 135.602C133.665 134.521 132.789 133.646 131.709 133.646C130.629 133.646 129.753 134.521 129.753 135.602C129.753 136.682 130.629 137.558 131.709 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_547",
    d: "M131.709 141.47C132.789 141.47 133.665 140.594 133.665 139.514C133.665 138.433 132.789 137.558 131.709 137.558C130.629 137.558 129.753 138.433 129.753 139.514C129.753 140.594 130.629 141.47 131.709 141.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_548",
    d: "M135.619 39.7521C136.7 39.7521 137.575 38.8763 137.575 37.796C137.575 36.7156 136.7 35.8398 135.619 35.8398C134.539 35.8398 133.663 36.7156 133.663 37.796C133.663 38.8763 134.539 39.7521 135.619 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_549",
    d: "M135.619 43.6642C136.7 43.6642 137.575 42.7884 137.575 41.7081C137.575 40.6277 136.7 39.752 135.619 39.752C134.539 39.752 133.663 40.6277 133.663 41.7081C133.663 42.7884 134.539 43.6642 135.619 43.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_550",
    d: "M135.619 47.5763C136.7 47.5763 137.575 46.7005 137.575 45.6202C137.575 44.5398 136.7 43.6641 135.619 43.6641C134.539 43.6641 133.663 44.5398 133.663 45.6202C133.663 46.7005 134.539 47.5763 135.619 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_551",
    d: "M135.619 51.4884C136.7 51.4884 137.575 50.6126 137.575 49.5323C137.575 48.452 136.7 47.5762 135.619 47.5762C134.539 47.5762 133.663 48.452 133.663 49.5323C133.663 50.6126 134.539 51.4884 135.619 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_552",
    d: "M135.619 55.4015C136.7 55.4015 137.575 54.5257 137.575 53.4454C137.575 52.365 136.7 51.4893 135.619 51.4893C134.539 51.4893 133.663 52.365 133.663 53.4454C133.663 54.5257 134.539 55.4015 135.619 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_553",
    d: "M135.619 59.3136C136.7 59.3136 137.575 58.4378 137.575 57.3575C137.575 56.2771 136.7 55.4014 135.619 55.4014C134.539 55.4014 133.663 56.2771 133.663 57.3575C133.663 58.4378 134.539 59.3136 135.619 59.3136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_554",
    d: "M135.619 63.2257C136.7 63.2257 137.575 62.3499 137.575 61.2696C137.575 60.1893 136.7 59.3135 135.619 59.3135C134.539 59.3135 133.663 60.1893 133.663 61.2696C133.663 62.3499 134.539 63.2257 135.619 63.2257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_555",
    d: "M135.619 67.1378C136.7 67.1378 137.575 66.262 137.575 65.1817C137.575 64.1014 136.7 63.2256 135.619 63.2256C134.539 63.2256 133.663 64.1014 133.663 65.1817C133.663 66.262 134.539 67.1378 135.619 67.1378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_556",
    d: "M135.619 71.0499C136.7 71.0499 137.575 70.1741 137.575 69.0938C137.575 68.0135 136.7 67.1377 135.619 67.1377C134.539 67.1377 133.663 68.0135 133.663 69.0938C133.663 70.1741 134.539 71.0499 135.619 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_557",
    d: "M135.619 78.8741C136.7 78.8741 137.575 77.9984 137.575 76.918C137.575 75.8377 136.7 74.9619 135.619 74.9619C134.539 74.9619 133.663 75.8377 133.663 76.918C133.663 77.9984 134.539 78.8741 135.619 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_558",
    d: "M135.619 86.6993C136.7 86.6993 137.575 85.8236 137.575 84.7432C137.575 83.6629 136.7 82.7871 135.619 82.7871C134.539 82.7871 133.663 83.6629 133.663 84.7432C133.663 85.8236 134.539 86.6993 135.619 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_559",
    d: "M135.619 90.6114C136.7 90.6114 137.575 89.7357 137.575 88.6553C137.575 87.575 136.7 86.6992 135.619 86.6992C134.539 86.6992 133.663 87.575 133.663 88.6553C133.663 89.7357 134.539 90.6114 135.619 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_560",
    d: "M135.619 94.5236C136.7 94.5236 137.575 93.6478 137.575 92.5674C137.575 91.4871 136.7 90.6113 135.619 90.6113C134.539 90.6113 133.663 91.4871 133.663 92.5674C133.663 93.6478 134.539 94.5236 135.619 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_561",
    d: "M135.619 106.26C136.7 106.26 137.575 105.384 137.575 104.304C137.575 103.223 136.7 102.348 135.619 102.348C134.539 102.348 133.663 103.223 133.663 104.304C133.663 105.384 134.539 106.26 135.619 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_562",
    d: "M135.619 110.172C136.7 110.172 137.575 109.296 137.575 108.216C137.575 107.136 136.7 106.26 135.619 106.26C134.539 106.26 133.663 107.136 133.663 108.216C133.663 109.296 134.539 110.172 135.619 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_563",
    d: "M135.619 114.084C136.7 114.084 137.575 113.208 137.575 112.128C137.575 111.048 136.7 110.172 135.619 110.172C134.539 110.172 133.663 111.048 133.663 112.128C133.663 113.208 134.539 114.084 135.619 114.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_564",
    d: "M135.619 121.909C136.7 121.909 137.575 121.034 137.575 119.953C137.575 118.873 136.7 117.997 135.619 117.997C134.539 117.997 133.663 118.873 133.663 119.953C133.663 121.034 134.539 121.909 135.619 121.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_565",
    d: "M135.619 125.821C136.7 125.821 137.575 124.946 137.575 123.865C137.575 122.785 136.7 121.909 135.619 121.909C134.539 121.909 133.663 122.785 133.663 123.865C133.663 124.946 134.539 125.821 135.619 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_566",
    d: "M135.619 133.646C136.7 133.646 137.575 132.77 137.575 131.69C137.575 130.609 136.7 129.733 135.619 129.733C134.539 129.733 133.663 130.609 133.663 131.69C133.663 132.77 134.539 133.646 135.619 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_567",
    d: "M135.619 137.558C136.7 137.558 137.575 136.682 137.575 135.602C137.575 134.521 136.7 133.646 135.619 133.646C134.539 133.646 133.663 134.521 133.663 135.602C133.663 136.682 134.539 137.558 135.619 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_568",
    d: "M135.619 141.47C136.7 141.47 137.575 140.594 137.575 139.514C137.575 138.433 136.7 137.558 135.619 137.558C134.539 137.558 133.663 138.433 133.663 139.514C133.663 140.594 134.539 141.47 135.619 141.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_569",
    d: "M139.531 35.84C140.612 35.84 141.487 34.9642 141.487 33.8838C141.487 32.8035 140.612 31.9277 139.531 31.9277C138.451 31.9277 137.575 32.8035 137.575 33.8838C137.575 34.9642 138.451 35.84 139.531 35.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_570",
    d: "M139.531 47.5763C140.612 47.5763 141.487 46.7005 141.487 45.6202C141.487 44.5398 140.612 43.6641 139.531 43.6641C138.451 43.6641 137.575 44.5398 137.575 45.6202C137.575 46.7005 138.451 47.5763 139.531 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_571",
    d: "M139.531 51.4884C140.612 51.4884 141.487 50.6126 141.487 49.5323C141.487 48.452 140.612 47.5762 139.531 47.5762C138.451 47.5762 137.575 48.452 137.575 49.5323C137.575 50.6126 138.451 51.4884 139.531 51.4884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_572",
    d: "M139.531 55.4015C140.612 55.4015 141.487 54.5257 141.487 53.4454C141.487 52.365 140.612 51.4893 139.531 51.4893C138.451 51.4893 137.575 52.365 137.575 53.4454C137.575 54.5257 138.451 55.4015 139.531 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_573",
    d: "M139.531 74.962C140.612 74.962 141.487 74.0863 141.487 73.0059C141.487 71.9256 140.612 71.0498 139.531 71.0498C138.451 71.0498 137.575 71.9256 137.575 73.0059C137.575 74.0863 138.451 74.962 139.531 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_574",
    d: "M139.531 78.8741C140.612 78.8741 141.487 77.9984 141.487 76.918C141.487 75.8377 140.612 74.9619 139.531 74.9619C138.451 74.9619 137.575 75.8377 137.575 76.918C137.575 77.9984 138.451 78.8741 139.531 78.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_575",
    d: "M139.531 82.7863C140.612 82.7863 141.487 81.9105 141.487 80.8301C141.487 79.7498 140.612 78.874 139.531 78.874C138.451 78.874 137.575 79.7498 137.575 80.8301C137.575 81.9105 138.451 82.7863 139.531 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_576",
    d: "M139.531 86.6993C140.612 86.6993 141.487 85.8236 141.487 84.7432C141.487 83.6629 140.612 82.7871 139.531 82.7871C138.451 82.7871 137.575 83.6629 137.575 84.7432C137.575 85.8236 138.451 86.6993 139.531 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_577",
    d: "M139.531 94.5236C140.612 94.5236 141.487 93.6478 141.487 92.5674C141.487 91.4871 140.612 90.6113 139.531 90.6113C138.451 90.6113 137.575 91.4871 137.575 92.5674C137.575 93.6478 138.451 94.5236 139.531 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_578",
    d: "M139.531 106.26C140.612 106.26 141.487 105.384 141.487 104.304C141.487 103.223 140.612 102.348 139.531 102.348C138.451 102.348 137.575 103.223 137.575 104.304C137.575 105.384 138.451 106.26 139.531 106.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_579",
    d: "M139.531 110.172C140.612 110.172 141.487 109.296 141.487 108.216C141.487 107.136 140.612 106.26 139.531 106.26C138.451 106.26 137.575 107.136 137.575 108.216C137.575 109.296 138.451 110.172 139.531 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_580",
    d: "M139.531 117.997C140.612 117.997 141.487 117.121 141.487 116.041C141.487 114.961 140.612 114.085 139.531 114.085C138.451 114.085 137.575 114.961 137.575 116.041C137.575 117.121 138.451 117.997 139.531 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_581",
    d: "M139.531 125.821C140.612 125.821 141.487 124.946 141.487 123.865C141.487 122.785 140.612 121.909 139.531 121.909C138.451 121.909 137.575 122.785 137.575 123.865C137.575 124.946 138.451 125.821 139.531 125.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_582",
    d: "M139.531 129.734C140.612 129.734 141.487 128.858 141.487 127.777C141.487 126.697 140.612 125.821 139.531 125.821C138.451 125.821 137.575 126.697 137.575 127.777C137.575 128.858 138.451 129.734 139.531 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_583",
    d: "M139.531 137.558C140.612 137.558 141.487 136.682 141.487 135.602C141.487 134.521 140.612 133.646 139.531 133.646C138.451 133.646 137.575 134.521 137.575 135.602C137.575 136.682 138.451 137.558 139.531 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_584",
    d: "M139.531 141.47C140.612 141.47 141.487 140.594 141.487 139.514C141.487 138.433 140.612 137.558 139.531 137.558C138.451 137.558 137.575 138.433 137.575 139.514C137.575 140.594 138.451 141.47 139.531 141.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_585",
    d: "M143.445 39.7521C144.526 39.7521 145.401 38.8763 145.401 37.796C145.401 36.7156 144.526 35.8398 143.445 35.8398C142.365 35.8398 141.489 36.7156 141.489 37.796C141.489 38.8763 142.365 39.7521 143.445 39.7521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_586",
    d: "M143.445 47.5763C144.526 47.5763 145.401 46.7005 145.401 45.6202C145.401 44.5398 144.526 43.6641 143.445 43.6641C142.365 43.6641 141.489 44.5398 141.489 45.6202C141.489 46.7005 142.365 47.5763 143.445 47.5763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_587",
    d: "M143.445 55.4015C144.526 55.4015 145.401 54.5257 145.401 53.4454C145.401 52.365 144.526 51.4893 143.445 51.4893C142.365 51.4893 141.489 52.365 141.489 53.4454C141.489 54.5257 142.365 55.4015 143.445 55.4015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_588",
    d: "M143.445 71.0499C144.526 71.0499 145.401 70.1741 145.401 69.0938C145.401 68.0135 144.526 67.1377 143.445 67.1377C142.365 67.1377 141.489 68.0135 141.489 69.0938C141.489 70.1741 142.365 71.0499 143.445 71.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_589",
    d: "M143.445 74.962C144.526 74.962 145.401 74.0863 145.401 73.0059C145.401 71.9256 144.526 71.0498 143.445 71.0498C142.365 71.0498 141.489 71.9256 141.489 73.0059C141.489 74.0863 142.365 74.962 143.445 74.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_590",
    d: "M143.445 82.7863C144.526 82.7863 145.401 81.9105 145.401 80.8301C145.401 79.7498 144.526 78.874 143.445 78.874C142.365 78.874 141.489 79.7498 141.489 80.8301C141.489 81.9105 142.365 82.7863 143.445 82.7863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_591",
    d: "M143.445 86.6993C144.526 86.6993 145.401 85.8236 145.401 84.7432C145.401 83.6629 144.526 82.7871 143.445 82.7871C142.365 82.7871 141.489 83.6629 141.489 84.7432C141.489 85.8236 142.365 86.6993 143.445 86.6993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_592",
    d: "M143.445 90.6114C144.526 90.6114 145.401 89.7357 145.401 88.6553C145.401 87.575 144.526 86.6992 143.445 86.6992C142.365 86.6992 141.489 87.575 141.489 88.6553C141.489 89.7357 142.365 90.6114 143.445 90.6114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_593",
    d: "M143.445 94.5236C144.526 94.5236 145.401 93.6478 145.401 92.5674C145.401 91.4871 144.526 90.6113 143.445 90.6113C142.365 90.6113 141.489 91.4871 141.489 92.5674C141.489 93.6478 142.365 94.5236 143.445 94.5236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_594",
    d: "M143.445 98.4357C144.526 98.4357 145.401 97.5599 145.401 96.4796C145.401 95.3992 144.526 94.5234 143.445 94.5234C142.365 94.5234 141.489 95.3992 141.489 96.4796C141.489 97.5599 142.365 98.4357 143.445 98.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_595",
    d: "M143.445 110.172C144.526 110.172 145.401 109.296 145.401 108.216C145.401 107.136 144.526 106.26 143.445 106.26C142.365 106.26 141.489 107.136 141.489 108.216C141.489 109.296 142.365 110.172 143.445 110.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_596",
    d: "M143.445 117.997C144.526 117.997 145.401 117.121 145.401 116.041C145.401 114.961 144.526 114.085 143.445 114.085C142.365 114.085 141.489 114.961 141.489 116.041C141.489 117.121 142.365 117.997 143.445 117.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_597",
    d: "M143.445 137.558C144.526 137.558 145.401 136.682 145.401 135.602C145.401 134.521 144.526 133.646 143.445 133.646C142.365 133.646 141.489 134.521 141.489 135.602C141.489 136.682 142.365 137.558 143.445 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_598",
    d: "M143.445 141.47C144.526 141.47 145.401 140.594 145.401 139.514C145.401 138.433 144.526 137.558 143.445 137.558C142.365 137.558 141.489 138.433 141.489 139.514C141.489 140.594 142.365 141.47 143.445 141.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_599",
    d: "M143.445 145.382C144.526 145.382 145.401 144.506 145.401 143.426C145.401 142.346 144.526 141.47 143.445 141.47C142.365 141.47 141.489 142.346 141.489 143.426C141.489 144.506 142.365 145.382 143.445 145.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_600",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.648438 10.4105V18.2349C0.648437 20.8289 1.67889 23.3166 3.5131 25.1508C5.34731 26.985 7.83504 28.0155 10.429 28.0155H18.2535C19.5379 28.0155 20.8097 27.7625 21.9963 27.271C23.183 26.7795 24.2612 26.059 25.1694 25.1508C26.0776 24.2426 26.798 23.1644 27.2895 21.9778C27.7811 20.7911 28.034 19.5193 28.034 18.2349V10.4105C28.034 9.12605 27.7811 7.85423 27.2895 6.66759C26.798 5.48096 26.0776 4.40276 25.1694 3.49455C24.2612 2.58634 23.183 1.8659 21.9963 1.37438C20.8097 0.882865 19.5379 0.629883 18.2535 0.629883H10.429C7.83504 0.629883 5.34731 1.66033 3.5131 3.49455C1.67889 5.32876 0.648438 7.81649 0.648438 10.4105ZM10.429 4.54211H18.2535C19.8099 4.54211 21.3025 5.16038 22.403 6.26091C23.5035 7.36144 24.1218 8.85408 24.1218 10.4105V18.2349C24.1218 19.7913 23.5035 21.2839 22.403 22.3845C21.3025 23.485 19.8099 24.1033 18.2535 24.1033H10.429C8.87263 24.1033 7.37999 23.485 6.27947 22.3845C5.17894 21.2839 4.56067 19.7913 4.56067 18.2349V10.4105C4.56067 8.85408 5.17894 7.36144 6.27947 6.26091C7.37999 5.16038 8.87263 4.54211 10.429 4.54211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_601",
    d: "M10.4288 12.3663C11.5091 12.3663 12.3849 11.4905 12.3849 10.4102C12.3849 9.32988 11.5091 8.4541 10.4288 8.4541C9.34844 8.4541 8.47266 9.32988 8.47266 10.4102C8.47266 11.4905 9.34844 12.3663 10.4288 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_602",
    d: "M10.4288 16.2784C11.5091 16.2784 12.3849 15.4027 12.3849 14.3223C12.3849 13.242 11.5091 12.3662 10.4288 12.3662C9.34844 12.3662 8.47266 13.242 8.47266 14.3223C8.47266 15.4027 9.34844 16.2784 10.4288 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_603",
    d: "M10.4288 20.1905C11.5091 20.1905 12.3849 19.3148 12.3849 18.2344C12.3849 17.1541 11.5091 16.2783 10.4288 16.2783C9.34844 16.2783 8.47266 17.1541 8.47266 18.2344C8.47266 19.3148 9.34844 20.1905 10.4288 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_604",
    d: "M14.3409 12.3663C15.4212 12.3663 16.297 11.4905 16.297 10.4102C16.297 9.32988 15.4212 8.4541 14.3409 8.4541C13.2605 8.4541 12.3848 9.32988 12.3848 10.4102C12.3848 11.4905 13.2605 12.3663 14.3409 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_605",
    d: "M14.3409 16.2784C15.4212 16.2784 16.297 15.4027 16.297 14.3223C16.297 13.242 15.4212 12.3662 14.3409 12.3662C13.2605 12.3662 12.3848 13.242 12.3848 14.3223C12.3848 15.4027 13.2605 16.2784 14.3409 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_606",
    d: "M14.3409 20.1905C15.4212 20.1905 16.297 19.3148 16.297 18.2344C16.297 17.1541 15.4212 16.2783 14.3409 16.2783C13.2605 16.2783 12.3848 17.1541 12.3848 18.2344C12.3848 19.3148 13.2605 20.1905 14.3409 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_607",
    d: "M18.254 12.3663C19.3343 12.3663 20.2101 11.4905 20.2101 10.4102C20.2101 9.32988 19.3343 8.4541 18.254 8.4541C17.1736 8.4541 16.2979 9.32988 16.2979 10.4102C16.2979 11.4905 17.1736 12.3663 18.254 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_608",
    d: "M18.254 16.2784C19.3343 16.2784 20.2101 15.4027 20.2101 14.3223C20.2101 13.242 19.3343 12.3662 18.254 12.3662C17.1736 12.3662 16.2979 13.242 16.2979 14.3223C16.2979 15.4027 17.1736 16.2784 18.254 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_609",
    d: "M18.254 20.1905C19.3343 20.1905 20.2101 19.3148 20.2101 18.2344C20.2101 17.1541 19.3343 16.2783 18.254 16.2783C17.1736 16.2783 16.2979 17.1541 16.2979 18.2344C16.2979 19.3148 17.1736 20.1905 18.254 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_610",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.621 0.629883L127.796 0.629883C125.202 0.629883 122.715 1.66033 120.88 3.49455C119.046 5.32876 118.016 7.81649 118.016 10.4105V18.2349C118.016 19.5193 118.269 20.7911 118.76 21.9778C119.252 23.1644 119.972 24.2426 120.88 25.1508C121.789 26.059 122.867 26.7795 124.053 27.271C125.24 27.7625 126.512 28.0155 127.796 28.0155H135.621C138.215 28.0155 140.702 26.985 142.537 25.1508C144.371 23.3166 145.401 20.8289 145.401 18.2349V10.4105C145.401 7.81649 144.371 5.32876 142.537 3.49455C140.702 1.66033 138.215 0.629883 135.621 0.629883ZM141.489 10.4105V18.2349C141.489 19.7913 140.871 21.2839 139.77 22.3845C138.67 23.485 137.177 24.1033 135.621 24.1033H127.796C126.24 24.1033 124.747 23.485 123.647 22.3845C122.546 21.2839 121.928 19.7913 121.928 18.2349V10.4105C121.928 8.85408 122.546 7.36144 123.647 6.26091C124.747 5.16039 126.24 4.54211 127.796 4.54211L135.621 4.54211C137.177 4.54211 138.67 5.16039 139.77 6.26091C140.871 7.36144 141.489 8.85408 141.489 10.4105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_611",
    d: "M127.796 12.3663C128.876 12.3663 129.752 11.4905 129.752 10.4102C129.752 9.32988 128.876 8.4541 127.796 8.4541C126.716 8.4541 125.84 9.32988 125.84 10.4102C125.84 11.4905 126.716 12.3663 127.796 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_612",
    d: "M127.796 16.2784C128.876 16.2784 129.752 15.4027 129.752 14.3223C129.752 13.242 128.876 12.3662 127.796 12.3662C126.716 12.3662 125.84 13.242 125.84 14.3223C125.84 15.4027 126.716 16.2784 127.796 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_613",
    d: "M127.796 20.1905C128.876 20.1905 129.752 19.3148 129.752 18.2344C129.752 17.1541 128.876 16.2783 127.796 16.2783C126.716 16.2783 125.84 17.1541 125.84 18.2344C125.84 19.3148 126.716 20.1905 127.796 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_614",
    d: "M131.709 12.3663C132.789 12.3663 133.665 11.4905 133.665 10.4102C133.665 9.32988 132.789 8.4541 131.709 8.4541C130.629 8.4541 129.753 9.32988 129.753 10.4102C129.753 11.4905 130.629 12.3663 131.709 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_615",
    d: "M131.709 16.2784C132.789 16.2784 133.665 15.4027 133.665 14.3223C133.665 13.242 132.789 12.3662 131.709 12.3662C130.629 12.3662 129.753 13.242 129.753 14.3223C129.753 15.4027 130.629 16.2784 131.709 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_616",
    d: "M131.709 20.1905C132.789 20.1905 133.665 19.3148 133.665 18.2344C133.665 17.1541 132.789 16.2783 131.709 16.2783C130.629 16.2783 129.753 17.1541 129.753 18.2344C129.753 19.3148 130.629 20.1905 131.709 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_617",
    d: "M135.619 12.3663C136.7 12.3663 137.575 11.4905 137.575 10.4102C137.575 9.32988 136.7 8.4541 135.619 8.4541C134.539 8.4541 133.663 9.32988 133.663 10.4102C133.663 11.4905 134.539 12.3663 135.619 12.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_618",
    d: "M135.619 16.2784C136.7 16.2784 137.575 15.4027 137.575 14.3223C137.575 13.242 136.7 12.3662 135.619 12.3662C134.539 12.3662 133.663 13.242 133.663 14.3223C133.663 15.4027 134.539 16.2784 135.619 16.2784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_619",
    d: "M135.619 20.1905C136.7 20.1905 137.575 19.3148 137.575 18.2344C137.575 17.1541 136.7 16.2783 135.619 16.2783C134.539 16.2783 133.663 17.1541 133.663 18.2344C133.663 19.3148 134.539 20.1905 135.619 20.1905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_620",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.429 145.383H18.2535C20.8474 145.383 23.3352 144.352 25.1694 142.518C27.0036 140.684 28.034 138.196 28.034 135.602V127.778C28.034 126.493 27.7811 125.222 27.2895 124.035C26.798 122.848 26.0776 121.77 25.1694 120.862C24.2612 119.954 23.183 119.233 21.9963 118.742C20.8097 118.25 19.5379 117.997 18.2535 117.997H10.429C9.14461 117.997 7.87278 118.25 6.68615 118.742C5.49951 119.233 4.42131 119.954 3.5131 120.862C2.60489 121.77 1.88446 122.848 1.39294 124.035C0.901422 125.222 0.648437 126.493 0.648438 127.778L0.648438 135.602C0.648438 138.196 1.67889 140.684 3.5131 142.518C5.34731 144.352 7.83504 145.383 10.429 145.383ZM4.56067 135.602L4.56067 127.778C4.56067 126.221 5.17894 124.729 6.27947 123.628C7.38 122.528 8.87263 121.909 10.429 121.909H18.2535C19.8099 121.909 21.3025 122.528 22.403 123.628C23.5035 124.729 24.1218 126.221 24.1218 127.778V135.602C24.1218 137.159 23.5035 138.651 22.403 139.752C21.3025 140.852 19.8099 141.471 18.2535 141.471H10.429C8.87263 141.471 7.38 140.852 6.27947 139.752C5.17894 138.651 4.56067 137.159 4.56067 135.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_621",
    d: "M10.4288 129.734C11.5091 129.734 12.3849 128.858 12.3849 127.777C12.3849 126.697 11.5091 125.821 10.4288 125.821C9.34844 125.821 8.47266 126.697 8.47266 127.777C8.47266 128.858 9.34844 129.734 10.4288 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_622",
    d: "M10.4288 133.646C11.5091 133.646 12.3849 132.77 12.3849 131.69C12.3849 130.609 11.5091 129.733 10.4288 129.733C9.34844 129.733 8.47266 130.609 8.47266 131.69C8.47266 132.77 9.34844 133.646 10.4288 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_623",
    d: "M10.4288 137.558C11.5091 137.558 12.3849 136.682 12.3849 135.602C12.3849 134.521 11.5091 133.646 10.4288 133.646C9.34844 133.646 8.47266 134.521 8.47266 135.602C8.47266 136.682 9.34844 137.558 10.4288 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_624",
    d: "M14.3409 129.734C15.4212 129.734 16.297 128.858 16.297 127.777C16.297 126.697 15.4212 125.821 14.3409 125.821C13.2605 125.821 12.3848 126.697 12.3848 127.777C12.3848 128.858 13.2605 129.734 14.3409 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_625",
    d: "M14.3409 133.646C15.4212 133.646 16.297 132.77 16.297 131.69C16.297 130.609 15.4212 129.733 14.3409 129.733C13.2605 129.733 12.3848 130.609 12.3848 131.69C12.3848 132.77 13.2605 133.646 14.3409 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_626",
    d: "M14.3409 137.558C15.4212 137.558 16.297 136.682 16.297 135.602C16.297 134.521 15.4212 133.646 14.3409 133.646C13.2605 133.646 12.3848 134.521 12.3848 135.602C12.3848 136.682 13.2605 137.558 14.3409 137.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_627",
    d: "M18.254 129.734C19.3343 129.734 20.2101 128.858 20.2101 127.777C20.2101 126.697 19.3343 125.821 18.254 125.821C17.1736 125.821 16.2979 126.697 16.2979 127.777C16.2979 128.858 17.1736 129.734 18.254 129.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_628",
    d: "M18.254 133.646C19.3343 133.646 20.2101 132.77 20.2101 131.69C20.2101 130.609 19.3343 129.733 18.254 129.733C17.1736 129.733 16.2979 130.609 16.2979 131.69C16.2979 132.77 17.1736 133.646 18.254 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_629",
    d: "M18.254 137.558C19.3343 137.558 20.2101 136.682 20.2101 135.602C20.2101 134.521 19.3343 133.646 18.254 133.646C17.1736 133.646 16.2979 134.521 16.2979 135.602C16.2979 136.682 17.1736 137.558 18.254 137.558Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_795_82616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_630",
    d: "M146.379 -0.348633H-0.330078V146.36H146.379V-0.348633Z",
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstoreQr);
export default __webpack_public_path__ + "static/media/appstore-qr.055326c34afb8f8f69c7b1139a683507.svg";
export { ForwardRef as ReactComponent };